<nz-skeleton *ngIf="!configData && !trasactionPageDataStateMap" [nzAvatar]="false" [nzActive]="true" [nzTitle]="true"
  [nzLoading]="!configData">
</nz-skeleton>
<ng-container *ngIf="configData">

  <div class="card-container">
    <app-transaction-summary-ribbon [state]="mapperTransactionState" [policyData]="payloadInEdit"
      [RequirementEntityGuid]="transactionGuid" (documentManagerHandler)="documentManagerHandler($event)"
      (policyManagerHandler)="policySummary($event)" (medicalRiskHandler)="medicalRiskHandler($event)">
    </app-transaction-summary-ribbon>
  </div>

  <div *ngIf="mapperTransactionState == 'proposal_ManualUw' && exclusionsList != null && exclusionList.length > 0">
    <app-ui-accordion-small [dataList]="productSpecificationList" [title]="'Exclusions'" [toggleFor]="'exclusions'"
      [IO]="payloadInEdit">
    </app-ui-accordion-small>
  </div>
  
  <div class="m-t-10"
    *ngIf="mapperTransactionState == 'proposal_ManualUw' && termConditionData != null && termConditionData.length > 0">
    <app-ui-accordion-small [dataList]="productSpecificationList" [title]="'Terms and Conditions'" [toggleFor]="'tAndc'"
      [IO]="payloadInEdit">
    </app-ui-accordion-small>
  </div>

  <div [class.grid]="dataTransformService.isSidebarCollapsed && appMetadataHandler.featureFlags.enableDataEntryMode && false"
    [class.grid-60-auto]="dataTransformService.isSidebarCollapsed && appMetadataHandler.featureFlags.enableDataEntryMode && false"
    [class.grid-gap-10]="dataTransformService.isSidebarCollapsed && appMetadataHandler.featureFlags.enableDataEntryMode && false">
    <div>
      <!-- tab layout -->
      <div>

        <!--<p>
      <a (click)="docuPanel(1)"><i class="anticon anticon-paper-clip"></i> Documents</a>
    </p>-->

        <!-- Pending Tasks ? -->
        <div class="m-t-20" *ngIf="state=='adjudication'">
          <span class="clickable" (click)="pendingPanel(1)">
            <nz-alert nzType="warning" nzCloseable nzMessage="2 ongoing tasks for this claim" nzShowIcon>
            </nz-alert>
          </span>
        </div>

        <!-- ===== DRAGGABLE BOXES ===== -->
      <div class="draggable-modals"
        *ngIf="payloadInEdit && ((payloadInEdit.proposalDO && payloadInEdit.proposalDO.proposalNum) || (payloadInEdit.caseDO && payloadInEdit.caseDO.proposalNum))">
        <ng-container *ngFor="let box of draggableBoxes;let i = index;">
          <div class="draggable-modal resizeable-modal" cdkDrag cdkDragBoundary=".draggable-modal-boundary" [ngStyle]="{
             'width': box.width, 'min-width': box.minWidth||'auto', 'height': box.height,
             'top': '5%', 'left': (i+1.15)*10+'%', 'z-index': box.zIndex
             }" (click)="bringDraggableBoxToTop(i)" *ngIf="box.open && !box.minimized">
            <div class="draggable-modal-handle-container is-draggable" cdkDragHandle>
              <h4 *ngIf="box.title" class="d-b-head">{{box.title}}</h4>
              <div class="draggable-modal-handle-controls">
                <span class="d-b-button d-b-handle is-draggable">
                  <i nz-icon nzType="drag"></i>
                </span>
                <span class="d-b-button" (click)="closeSplitMode(box);floatingImgViewerEnableZoom=false;togglePreviewBtn=false;">
                  <i nz-icon nzType="minus"></i>
                </span>
              </div>
            </div>
            <div class="draggable-modal-content">
              <app-view-policy-summary [IO]="payloadInEdit" *ngIf="box.type=='policy-summary'"></app-view-policy-summary>
              <div *ngIf="box.type=='split-screen'">
                <!-- <div class="image-viewer-section m-t-20">Paper Application</div> -->
              <label class="m-t-l-10" nz-checkbox [(ngModel)]="floatingImgViewerEnableZoom">
                Enable Field Highlighter / Zoom
              </label>
              <!-- <button [hidden]="togglePreviewBtn" nz-button nzType="default"
                class="togglePreview" (click)="togglePreview()">
                <i nz-icon nzType="menu-unfold" nzTheme="outline"></i>
              </button>
              <div [hidden]="!togglePreviewBtn" class="previewBoxContainer">
                <div class="previewBoxBorder">
                  <div class="previewBoxFlex">
                    <div class="previewBoxTitle">Zoom Preview
                    </div>
                    <button nz-button nzType="default" (click)="togglePreview()" style="margin: 10px;"><i nz-icon nzType="menu-fold"
                        nzTheme="outline"></i></button>
                  </div>
                  <div id="floatingmyresult" class="img-zoom-result" style="background-color: #fff;"></div>
                </div>
              </div> -->
              <div *ngIf="!floatingImgViewerEnableZoom">
                <angular-image-viewer id="imageViewer" [src]="splitModeImages" style="position: relative;"></angular-image-viewer>
              </div>
              <!-- <div *ngIf="floatingImgViewerEnableZoom" class="img-zoom-container">
                <div id="lens-div" class="img-zoom-lens" (mousemove)="moveLens($event)"></div>
                <img id="floatingmyimage" style="height: 600px;width: 500px;" [src]="singleImgViewer"
                  (mousemove)="moveLens($event)">
              </div> -->
              <div  *ngIf="floatingImgViewerEnableZoom" class="img-zoom-container" style="height: 550px; overflow-y: auto" (scroll)="scrollHandler($event)">
                <div id="lens-div" class="img-zoom-lens" (mousemove)="moveLens($event)"></div>
                <img id="floatingmyimage" style="height:auto;width: 100%;" [src]="singleImgViewer" (mousemove)="moveLens($event)">
              </div>
              </div>
            </div>
          </div>
        </ng-container>
        <div class="draggable-modals-minimized">
          <ng-container *ngFor="let box of draggableBoxes;let i = index;">
            <div class="draggable-modal-min clickable" *ngIf="box.minimized && !box.open && box.isVisible"
              (click)="box.open=true;box.minimized=false;dataTransformService.isSidebarCollapsed=false;floatingImgViewerEnableZoom=true;togglePreviewBtn=true;" [ngStyle]="{'order':(i+1)}">
              <span class="draggable-modal-min-text txt-ovf-ellipsis">{{box.title}}</span>
              <div>
                <i nz-icon nzType="arrows-alt"></i>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    
      
        <!-- <div class="draggable-modals"> -->
        <!-- <app-ui-draggable-modal [RequirementEntityGuid]="transactionGuid" [payloadInEdit]="payloadInEdit"
          [dragBoxConfig]="draggableBoxes" [policyData]="policyData"></app-ui-draggable-modal> -->
        <!-- </div> -->
        <!-- ===== END DRAGGABLE BOXES ===== -->

        <!-- Comments -->
        <div class="m-t-20" *ngIf="state=='adjudication'">

          <div class="ant-alert ant-alert-info ant-alert-with-description" *ngIf="showLastNote">
            <i class="ant-alert-icon anticon anticon-read"></i>

            <span class="ant-alert-message">
              Note from <b>Ryan Reynolds [Adjudicator]</b>
            </span>
            <span class="ant-alert-description">
              <small class="d-b m-b-10">2 April 2019 at 3:30 PM (1 day ago)</small>
              Please verify document proofs submitted. Especially the bills from Sacred Hearts Hospital.
            </span>
            <div class="p-t-10 d-b">
              <a (click)="notesPanel(1)">View all Notes</a>
              &nbsp;
              <a (click)="showLastNote=false;">Close</a>
            </div>
          </div>

        </div>

        <!-- Tabs -->
        <div class="m-t-20" *ngIf="dataView == 'grid-layout'">

          <!--
        <nz-radio-group [(ngModel)]="nzTabPosition" style="float:right;">
          <label nz-radio-button [nzValue]="'top'">Horizontal</label>
          <label nz-radio-button [nzValue]="'left'">Vertical</label>
        </nz-radio-group>
      -->

          <nz-tabset *ngIf="!isEditWithConfig" [nzTabBarExtraContent]="toggleView" [class.inputs-are-disabled]="mapperTransactionState == 'claimUWReferral' ||
      mapperTransactionState == 'claimReinsReferral'" style="height:auto" [nzTabPosition]="nzTabPosition"
            [(nzSelectedIndex)]="selectedIndex" (nzSelectChange)="log([$event])">

            <!-- INVESTIGATION (STATIC) Owner: Ganesh-->
            <nz-tab [nzTitle]="titleTmplBasicInvest" *ngIf="getTabVisibilityStatus('InvestigationDetails')">
              <ng-template #titleTmplBasicInvest>
                <i nz-icon nzType="safety"></i> Investigation Report
              </ng-template>

              <div class="tab-investigation"
                [ngClass]="{'inputs-are-disabled': !permissions.investigation_report.edit}">

                <!-- Tabset for TWO INVESTIGATORS -->
                <nz-tabset style="height:auto" [nzSize]="'large'">

                  <nz-tab [nzTitle]="titleTmplInvestigator1">
                    <ng-template #titleTmplInvestigator1>
                      <strong class="d-b">Investigator 2: Elliot Henderson (YOU!)</strong>
                      <p class="col-grey-dark m-b-5">
                        Investigation ongoing
                      </p>
                    </ng-template>

                    <div>
                      <div class="tab-investigation"
                        [ngClass]="{'inputs-are-disabled': !permissions.investigation_report.edit}">

                        <!-- Investigation Items -->

                        <div class="investigation-item">
                          <div class="heading-tab">
                            <h3 class="heading"><i nz-icon nzType="file-unknown"></i> Investigation Item I: Hospital
                              Records
                            </h3>
                          </div>
                          <div class="flexie-auto-grid">
                            <div class="flex-self-vert-start">
                              <h4 class="p-b-10">Observations</h4>
                              <textarea nz-input cols="30" rows="6" placeholder="Enter your observations..."></textarea>
                            </div>
                            <div class="flex-self-vert-start">
                              <h4 class="p-b-10">Supporting Documents <a (click)="docuPanel(1)">[Manage]</a></h4>
                              <nz-upload nzAction="https://jsonplaceholder.typicode.com/posts/"
                                nzListType="picture-card" [(nzFileList)]="defaultUploadsList"
                                [nzShowButton]="defaultUploadsList.length < 3" [nzShowUploadList]="showUploadList">
                                <i nz-icon nzType="plus" nzTheme="outline"></i>
                                <div class="ant-upload-text">Upload</div>
                              </nz-upload>
                            </div>
                          </div>
                        </div>
                        <div class="investigation-item">
                          <div class="heading-tab">
                            <h3 class="heading"><i nz-icon nzType="file-unknown"></i> Investigation Item II: Death
                              Certificate
                            </h3>
                          </div>
                          <div class="flexie-auto-grid">
                            <div class="flex-self-vert-start">
                              <h4 class="p-b-10">Observations</h4>
                              <textarea nz-input cols="30" rows="6" placeholder="Enter your observations..."></textarea>
                            </div>
                            <div class="flex-self-vert-start">
                              <h4 class="p-b-10">Supporting Documents <a (click)="docuPanel(1)">[Manage]</a></h4>
                              <nz-upload nzAction="https://jsonplaceholder.typicode.com/posts/"
                                nzListType="picture-card" [(nzFileList)]="defaultUploadsList"
                                [nzShowButton]="defaultUploadsList.length < 3" [nzShowUploadList]="showUploadList">
                                <i nz-icon nzType="plus" nzTheme="outline"></i>
                                <div class="ant-upload-text">Upload</div>
                              </nz-upload>
                            </div>
                          </div>
                        </div>

                        <!-- Overall Summary -->

                        <div class="heading-tab">
                          <h3 class="heading"><i nz-icon nzType="file-text"></i> Overall summary of investigation</h3>
                        </div>

                        <div class="flexie-auto-grid">
                          <!-- Summary Textbox -->
                          <div class="flex-self-vert-start">
                            <h3 class="heading">Summary</h3>
                            <textarea nz-input cols="30" rows="6" placeholder="Enter your summary ..."></textarea>
                          </div>
                          <!-- Summary : Final Verdict -->
                          <div class="flex-self-vert-start">
                            <h3 class="heading">Verdict / Final Recommendation</h3>

                            <nz-radio-group [(ngModel)]="investiVerdict">
                              <span class="d-b p-t-b-10">
                                <label nz-radio nzValue="A"><span class="f-w-600 col-green">OK to proceed</span></label>
                              </span>
                              <!--<span class="d-b p-t-b-10">
                          <label nz-radio
                                 nzValue="B"><span class="f-w-600 col-orange">Proceed with caution / More investigation
                            required</span></label>
                          </span>-->
                              <span class="d-b p-t-b-10">
                                <label nz-radio nzValue="C"><span class="f-w-600 col-red">Do not proceed</span></label>
                              </span>
                              <!--<span class="d-b p-t-b-10">
                          <label nz-radio nzValue="O">
                            Other...
                            <input type="text" nz-input *ngIf="investiVerdict == 'O'" style="width: 100px; margin-left: 10px;" />
                          </label>
                          </span>-->
                            </nz-radio-group>
                          </div>
                        </div>

                      </div>
                    </div>

                  </nz-tab>

                  <nz-tab [nzTitle]="titleTmplInvestigator2">
                    <ng-template #titleTmplInvestigator2>
                      <strong class="d-b">Investigator 1: Kevin Fergie</strong>
                      <p class="col-green m-b-5">
                        Investigation Complete
                      </p>
                    </ng-template>

                    <div class="inputs-are-disabled">
                      <div class="tab-investigation"
                        [ngClass]="{'inputs-are-disabled': !permissions.investigation_report.edit}">

                        <!-- Investigation Items -->

                        <div class="investigation-item">
                          <div class="heading-tab">
                            <h3 class="heading"><i nz-icon nzType="file-unknown"></i> Investigation Item I: Hospital
                              Records
                            </h3>
                          </div>
                          <div class="flexie-auto-grid">
                            <div class="flex-self-vert-start">
                              <h4 class="p-b-10">Observations</h4>
                              <textarea nz-input cols="30" rows="6" placeholder="Enter your observations..."></textarea>
                            </div>
                            <div class="flex-self-vert-start">
                              <h4 class="p-b-10">Supporting Documents <a (click)="docuPanel(1)">[Manage]</a></h4>
                              <nz-upload nzAction="https://jsonplaceholder.typicode.com/posts/"
                                nzListType="picture-card" [(nzFileList)]="defaultUploadsList"
                                [nzShowButton]="defaultUploadsList.length < 3" [nzShowUploadList]="showUploadList">
                                <i nz-icon nzType="plus" nzTheme="outline"></i>
                                <div class="ant-upload-text">Upload</div>
                              </nz-upload>
                            </div>
                          </div>
                        </div>
                        <div class="investigation-item">
                          <div class="heading-tab">
                            <h3 class="heading"><i nz-icon nzType="file-unknown"></i> Investigation Item II: Death
                              Certificate
                            </h3>
                          </div>
                          <div class="flexie-auto-grid">
                            <div class="flex-self-vert-start">
                              <h4 class="p-b-10">Observations</h4>
                              <textarea nz-input cols="30" rows="6" placeholder="Enter your observations..."></textarea>
                            </div>
                            <div class="flex-self-vert-start">
                              <h4 class="p-b-10">Supporting Documents <a (click)="docuPanel(1)">[Manage]</a></h4>
                              <nz-upload nzAction="https://jsonplaceholder.typicode.com/posts/"
                                nzListType="picture-card" [(nzFileList)]="defaultUploadsList"
                                [nzShowButton]="defaultUploadsList.length < 3" [nzShowUploadList]="showUploadList">
                                <i nz-icon nzType="plus" nzTheme="outline"></i>
                                <div class="ant-upload-text">Upload</div>
                              </nz-upload>
                            </div>
                          </div>
                        </div>

                        <!-- Overall Summary -->

                        <div class="heading-tab">
                          <h3 class="heading"><i nz-icon nzType="file-text"></i> Overall summary of investigation</h3>
                        </div>

                        <div class="flexie-auto-grid">
                          <!-- Summary Textbox -->
                          <div class="flex-self-vert-start">
                            <h3 class="heading">Summary</h3>
                            <textarea nz-input cols="30" rows="6" placeholder="Enter your summary ..."></textarea>
                          </div>
                          <!-- Summary : Final Verdict -->
                          <div class="flex-self-vert-start">
                            <h3 class="heading">Verdict / Final Recommendation</h3>

                            <nz-radio-group [(ngModel)]="investiVerdict">
                              <span class="d-b p-t-b-10">
                                <label nz-radio nzValue="A"><span class="f-w-600 col-green">OK to proceed</span></label>
                              </span>
                              <!--<span class="d-b p-t-b-10">
                          <label nz-radio
                                 nzValue="B"><span class="f-w-600 col-orange">Proceed with caution / More investigation
                            required</span></label>
                          </span>-->
                              <span class="d-b p-t-b-10">
                                <label nz-radio nzValue="C"><span class="f-w-600 col-red">Do not proceed</span></label>
                              </span>
                              <!--<span class="d-b p-t-b-10">
                          <label nz-radio nzValue="O">
                            Other...
                            <input type="text" nz-input *ngIf="investiVerdict == 'O'" style="width: 100px; margin-left: 10px;" />
                          </label>
                          </span>-->
                            </nz-radio-group>
                          </div>
                        </div>

                      </div>
                    </div>

                  </nz-tab>

                </nz-tabset>

              </div>

            </nz-tab>

            <!-- TODO ninad transaction tabs start  -->

            <nz-tab [nzTitle]="titleTmplBasicDtl" *ngIf="hideTab"
            (nzSelect)="log(['select', tab])" (nzClick)="log(['click', tab])" (nzDeselect)="log(['deselect', tab])">
            <ng-template #titleTmplBasicDtl>
              <i nz-icon nzType="file-protect"></i> Proposal Review
            </ng-template>
            <div [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw' || disableTransaction">
              <app-underwriter-review [inputDataForEdit]="_inputAllClientListComponent" [configData]="configData"
              [transactionState]="mapperTransactionState" (emitStepToEnable)="enableStep($event)" [policyData]="payloadInEdit" [RequirementEntityGuid]="transactionGuid">
              </app-underwriter-review>
            </div>
            </nz-tab>
             
           <!-- Trip Details -->

           <nz-tab [nzTitle]="titleTmplBasicDtl" *ngIf="getTabVisibilityStatus('TripDetails')"
           (nzSelect)="log(['select', tab])" (nzClick)="log(['click', tab])" (nzDeselect)="log(['deselect', tab])">
           <ng-template #titleTmplBasicDtl>
             <i nz-icon nzType="file-text"></i> Trip Details
           </ng-template>
           <!-- <div [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw'">
             <app-generic-zero-ui [list]="this.tempAgentDetail"></app-generic-zero-ui>
           </div> -->
           <app-dynamic-form [baseDOName]="configData.StateToDOMapper[transactionState]"
             FORMTITLE="Trip Details" FORMNAME="TripDetailsForm" [IO]="payloadInEdit"
             (componentOutput)="_BaseEmitHandler($event, 'TripDetailsComponent')"
             [currentComponentName]="'TripDetailsComponent'"
             [formMetaData]="configData.ComponentMetaDataConfiguration.TripDetailsComponent">
           </app-dynamic-form>
         </nz-tab>

          <!-- Property Details -->

          <nz-tab [nzTitle]="titleTmplBasicDtl" *ngIf="getTabVisibilityStatus('PropertyDetails')"
          (nzSelect)="log(['select', tab])" (nzClick)="log(['click', tab])" (nzDeselect)="log(['deselect', tab])">
          <ng-template #titleTmplBasicDtl>
            <i nz-icon nzType="file-text"></i> Property 
          </ng-template>

          <app-dynamic-form [baseDOName]="configData.StateToDOMapper[mapperTransactionState]"
            FORMTITLE="Property Details" FORMNAME="PropertyDetailsForm" [IO]="payloadInEdit"
            (componentOutput)="_BaseEmitHandler($event, 'PropertyDetailsComponent')"
            [currentComponentName]="'PropertyDetailsComponent'"
            [formMetaData]="configData.ComponentMetaDataConfiguration.PropertyDetailsComponent">
          </app-dynamic-form>
          <!-- <div [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw'">
            <app-generic-zero-ui [list]="this.tempAgentDetail"></app-generic-zero-ui>
          </div> -->
          <div class="heading-tab">
            <h3 class="heading">Risk Location</h3>
          </div>
          <!-- <app-clinic-search-address [inputDataForEdit]="payloadInEdit" [provinceLevelLabel]="'Region'"
            [cityLevelLabel]="'District'" [pinCodeLevelLabel]="'Zip Code'" [areaLevelLabel]="'Area'"
            (componentOutput)="_BaseEmitHandler($event, 'PropertyDetailsAddressComponent')">
          </app-clinic-search-address> -->
          <ui-address-ind *ngIf="refreshComponentToggle" (componentOutput)="_BaseEmitHandler($event, 'PropertyDetailsAddressComponent')" 
            [inputDataForEdit]="_inputPropertyRiskLocation">
          </ui-address-ind>
        </nz-tab>


             <!-- vehicle  new--> 
             <nz-tab [nzTitle]="titleTmplBasicDtl" *ngIf="getTabVisibilityStatus('Motor')"
             (nzSelect)="log(['select', tab])" (nzClick)="log(['click', tab])" (nzDeselect)="log(['deselect', tab])">
             <ng-template #titleTmplBasicDtl>
               <i nz-icon nzType="file-protect"></i> Vehical Details
             </ng-template>
             <!-- <app-submission-data [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw'" [inputDataForEdit]="_inputSubmissionDataComponent"
                  [DOName]="_getDOName(TransactionState)" [transactionState]="mapperTransactionState"
                  [proposalType]="proposalType" [configData]="configData" [product]="selectedProduct"
                  [productFamilyCd]="productFamilyCd" (policyPackageType)="getPackageType($event)"
                  (componentOutput)="_BaseEmitHandler($event, 'SubmissionDataComponent')" (changedField)="getDataOnChange($event)">
                </app-submission-data> -->
                <app-vehicle-details [inputDataForEdit]="_inputVehicleDetailsComponent"
                [DOName]="_getDOName(TransactionState)" [transactionState]="mapperTransactionState"
                [proposalType]="proposalType" [configData]="configData" [product]="selectedProduct"
                [productFamilyCd]="productFamilyCd" (policyPackageType)="getPackageType($event)"
                (componentOutput)="_BaseEmitHandler($event, 'MotorInsuredDetailsComponent')">
              </app-vehicle-details>
             </nz-tab>


             <nz-tab [nzTitle]="titleTmplMotorTab" *ngIf="getTabVisibilityStatus('UnderwriterSummary23')"
             (nzSelect)="log(['select', tab])" (nzClick)="log(['click', tab])" (nzDeselect)="log(['deselect', tab])">
             <ng-template #titleTmplMotorTab>
               <i nz-icon nzType="file-protect"></i> Vehicle Details
             </ng-template>
             <!-- <div [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw'"> -->
 
               <app-vehicle-details [inputDataForEdit]="_inputVehicleDetailsComponent"
                 [DOName]="_getDOName(TransactionState)" [transactionState]="mapperTransactionState"
                 [proposalType]="proposalType" [configData]="configData" [product]="selectedProduct"
                 [productFamilyCd]="productFamilyCd" (policyPackageType)="getPackageType($event)"
                 (componentOutput)="_BaseEmitHandler($event, 'MotorInsuredDetailsComponent')">
               </app-vehicle-details>
 
             </nz-tab>
            
            <!-- Basic Details  -->

            <nz-tab [nzTitle]="titleTmplBasicDtl" *ngIf="getTabVisibilityStatus('BasicDetails')"
              (nzSelect)="log(['select', tab])" (nzClick)="log(['click', tab])" (nzDeselect)="log(['deselect', tab])">
              <ng-template #titleTmplBasicDtl>
                <i nz-icon nzType="solution"></i>  Basic Details
              </ng-template>
              <div [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw' || mapperTransactionState=='proposal_CounterOffer' || mapperTransactionState=='LIFEproposal_CounterOffer' || disableTransaction">

                <app-submission-data [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw'" [inputDataForEdit]="_inputSubmissionDataComponent"
                  [DOName]="_getDOName(TransactionState)" [transactionState]="mapperTransactionState"
                  [proposalType]="proposalType" [configData]="configData" [product]="selectedProduct"
                  [productFamilyCd]="productFamilyCd" (policyPackageType)="getPackageType($event)"
                  (componentOutput)="_BaseEmitHandler($event, 'SubmissionDataComponent')" (changedField)="getDataOnChange($event)">
                </app-submission-data>

                <!-- Policy Holder -->
                <app-client-list *ngIf="componentRefreshFl" [capturedRole]="constants.ROLES.OWNER"
                  [clientMaps]="_inputClientListComponent" (openSearchModal)="editSelectedClient($event, constants.ROLES.OWNER)"
                  (payerDataChanged)="onPayerDataChanged($event)">
                </app-client-list>

                <!-- Intermediary -->
                <app-captured-agent-list [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw'" class
                  captureRole="Intermediary" [agentList]="agentDataSet" [transactionState]="mapperTransactionState"
                  (componentOutput)="_BaseEmitHandler($event, 'CapturedAgentListComponent')" (openModal)="modSearchAgent=true"
                  [inputDataForEdit]="_inputAgentListComponent" (changedField)="getDataOnChange($event)">
                </app-captured-agent-list>
              </div>
            </nz-tab>

            <!-- Members -->
            <nz-tab [nzTitle]="titleTmplClaimant" *ngIf="getTabVisibilityStatus('InsuredMembersDetails')" [nzDisabled]="userRole == 'PROPOSAL_BRANCH_OFFICER'">
              <ng-template #titleTmplClaimant>
                <i nz-icon nzType="team"></i>Members
              </ng-template>
              <div>

                <!-- Primary Insured -->
                <app-client-list *ngIf="componentRefreshFl" [capturedRole]="constants.ROLES.PRIMARYINSURED" [clientMaps]="_inputClientListComponent"
                  (openSearchModal)="editSelectedClient($event, constants.ROLES.PRIMARYINSURED)">
                </app-client-list>
              
                <!-- Additional Insured -->
                <app-client-list *ngIf="componentRefreshFl" [capturedRole]="constants.ROLES.INSURED" [clientMaps]="_inputClientListComponent"
                  (openSearchModal)="editSelectedClient($event, constants.ROLES.INSURED)">
                </app-client-list>

                <!-- Payer -->
                <app-client-list *ngIf="componentRefreshFl" [capturedRole]="constants.ROLES.PAYER" [clientMaps]="_inputClientListComponent"
                  (openSearchModal)="editSelectedClient($event, constants.ROLES.PAYER)">
                </app-client-list>

                <!-- Nominee -->
                <app-client-list *ngIf="componentRefreshFl" [capturedRole]="constants.ROLES.NOMINEE" [clientMaps]="_inputClientListComponent"
                  (openSearchModal)="editSelectedClient($event, constants.ROLES.NOMINEE)">
                </app-client-list>

                <!-- Assignee -->
                <app-client-list *ngIf="componentRefreshFl" [capturedRole]="constants.ROLES.ASSIGNEE" [clientMaps]="_inputClientListComponent"
                  (openSearchModal)="editSelectedClient($event, constants.ROLES.ASSIGNEE)">
                </app-client-list>

                <!-- Appointee -->
                <app-client-list *ngIf="componentRefreshFl" [capturedRole]="constants.ROLES.APPOINTEE" [clientMaps]="_inputClientListComponent"
                  (openSearchModal)="editSelectedClient($event, constants.ROLES.APPOINTEE)">
                </app-client-list>

              </div>
            </nz-tab>

            <!-- Coverages -->
            <nz-tab [nzTitle]="titleTmplBasicDtl" *ngIf="getTabVisibilityStatus('Coverages')" [nzDisabled]="userRole == 'PROPOSAL_BRANCH_OFFICER'"
              (nzSelect)="log(['select', tab])" (nzClick)="log(['click', tab])" (nzDeselect)="log(['deselect', tab])">
              <ng-template #titleTmplBasicDtl>
                <i nz-icon nzType="carry-out"></i> Coverages
              </ng-template>
              <div *ngIf="!refreshThisComponenetOnSaveSubmit"
                style="display:block;border: 1px solid #dedede; padding: 40px; text-align:center;line-height: 1.5rem;color: #999">
                Saving coverages and calculating premium
              </div>

              <nz-skeleton *ngIf="!refreshThisComponenetOnSaveSubmit" [nzAvatar]="false" [nzActive]="true"
                [nzTitle]="true" [nzLoading]="!refreshThisComponenetOnSaveSubmit">
              </nz-skeleton>
              <div>
                <app-product-coverages [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw' || mapperTransactionState=='proposal_CounterOffer' || mapperTransactionState=='LIFEproposal_CounterOffer' || disableTransaction"
                 *ngIf="refreshThisComponenetOnSaveSubmit"
                  (componentOutput)="_BaseEmitHandler($event, 'ProductCoveragesComponent')"
                  (basePlanComponentOutput)="_BaseEmitHandler($event, 'BasePlanComponent')" [product]="selectedProduct"
                  [configData]="configData" [transactionState]="mapperTransactionState"
                  [transformType]="productFamilyCd" [inputDataForEdit]="payloadInEdit" title="Base Plan"
                  ExtractPlanTypeCd="RIDER" (changedField)="getDataOnChange($event)">
                </app-product-coverages>
              </div>
            </nz-tab>

            <!-- Fund Allocation -->
            <nz-tab [nzTitle]="titleTmplFundAllocDtl" *ngIf="getTabVisibilityStatus('Coverages') && dataTransformService.selectedProductType=='ULIP'" [nzDisabled]="userRole == 'PROPOSAL_BRANCH_OFFICER'"
              (nzSelect)="log(['select', tab])" (nzClick)="log(['click', tab])" (nzDeselect)="log(['deselect', tab])">
              <ng-template #titleTmplFundAllocDtl>
                <i nz-icon nzType="border-outer"></i> Fund Allocation
              </ng-template>
              <div>
                <app-input-grid-nested
                  [componentMetaData]="configData.ComponentMetaDataConfiguration.FundAllocationComponent"
                  [(ngModel)]="fundAllocationComponentData['ComponentData']"
                  [transactionState]="transactionState"
                  [currentComponent]="'FundAllocationComponent'" [IO]="payloadInEdit">
                </app-input-grid-nested>
              </div>
            </nz-tab>

            <!-- InsuredCoverageDecision TODO-->
            <nz-tab [nzTitle]="titleTmplBenefit" *ngIf="getTabVisibilityStatus('InsuredCoverageDecision') || (payloadInEdit && getDO(payloadInEdit) && getDO(payloadInEdit).statusCd != 'DRAFT' )" [nzDisabled]="(userRole == 'PROPOSAL_BRANCH_OFFICER')">
              <ng-template #titleTmplBenefit>
                <i nz-icon nzType="wallet"></i> Decision
              </ng-template>
              <ng-container *ngIf="appMetadataHandler.featureFlags.enableSingleDecisionOnDecisionBreakup">
                              <app-decision [configData]="configData" [DOName]="_getDOName(mapperTransactionState)" [inputDataForEdit]="_inputInsuredCoverageDecisionComponent"
                                  [transactionState]="mapperTransactionState"
                                  (componentOutputForDecisionForm) = "_BaseEmitHandler($event, 'ProposalDecisionComponent')"
                                  (componentOutputForCovergaeDecision) = "_BaseEmitHandler($event, 'CoverageDecisionComponent')">
                                </app-decision>
                            </ng-container>

                            <!-- Even If decision for Policy is selected all other decisions are visible -->
                            <ng-container
                              *ngIf="!appMetadataHandler.featureFlags.enableSingleDecisionOnDecisionBreakup">
                              <app-decision [configData]="configData" [DOName]="_getDOName(mapperTransactionState)" [inputDataForEdit]="_inputInsuredCoverageDecisionComponent"
                                  [transactionState]="mapperTransactionState"
                                  (componentOutputForDecisionForm) = "_BaseEmitHandler($event, 'ProposalDecisionComponent')"
                                  (componentOutputForCovergaeDecision) = "_BaseEmitHandler($event, 'CoverageDecisionComponent')">
                                </app-decision>
                              
                            </ng-container>

            </nz-tab>

            <!-- AutoUWRules -->
            <nz-tab [nzTitle]="titleTmplUWRules" *ngIf="getTabVisibilityStatus('AutoUWRules') && enableUWTab">
              <ng-template #titleTmplUWRules>
                <i nz-icon nzType="issues-close"></i> Underwriting Rules
              </ng-template>
              <!-- <div>
                <nz-table #autoUWRulesTable [nzData]="autuUWRules" [nzShowPagination]="false" [nzScroll]="{x:'1100px'}">
                  <thead class="table-header">
                    <tr>
                      <th class="">Rule Name</th>
                      <th class="">Rule Sub-type</th>
                      <th class="">Decision Type</th>
                      <th class="">Decision</th>
                      <th class="">Decision Value</th>
                      <th class="">Weight</th>
                      <th class="">Recommendation</th>
                    </tr>
                  </thead>
                  <tbody class="">
                    <tr class="table-row" *ngFor="let rule of autoUWRulesTable.data">
                      <td class="">{{ getRulesDescription(rule.ruleName, 'ruleName') }}</td>
                      <td class="">{{ getRulesDescription(rule.ruleSubType, 'ruleSubType') }}</td>
                      <td class="">{{ getRulesDescription(rule.decisionType, 'decisionType') }}</td>
                      <td class="">{{ getRulesDescription(rule.decision, 'decision') }}</td>
                      <td class="">{{rule.decisionValue}}</td>
                      <td class="">{{rule.weight}}</td>
                      <td class="">{{rule.recommendation}}</td>
                    </tr>
                  </tbody>
                </nz-table>
              </div> -->
              <app-rules-auto *ngIf="payloadInEdit" [IO]="payloadInEdit"></app-rules-auto>
            </nz-tab>

            <nz-tab [nzTitle]="titleTmplPayout" *ngIf="hideTab">
            <!-- <ng-template #titleTmplPayout>
             <em nz-icon type="audit"></em> {{'Fraud Analytics' | MMSTranslate}}
            </ng-template> -->
            <ng-template #titleTmplPayout>
              <i nz-icon nzType="audit"></i> Fraud Analytics
            </ng-template>
            <ng-container>
              <!-- <app-fraud-rules [IO]="payloadInEdit" [transactionState]="mapperTransactionState"
                [barcodeNum]='dataTransformService.barCodeNum'>
              </app-fraud-rules> -->
              <app-fwa-analytics [IO]="payloadInEdit" [configData]="configData"
                  [transactionState]="mapperTransactionState"></app-fwa-analytics>
            </ng-container>
            <!-- <nz-skeleton *ngIf="!dataTransformService.barCodeNum" [nzAvatar]="false" [nzActive]="true"
              [nzLoading]="!dataTransformService.barCodeNum"></nz-skeleton> -->
      
          </nz-tab>
            <!-- <nz-tab [nzTitle]="titleTmplPayout">
            <ng-template #titleTmplPayout>
             <em nz-icon type="audit"></em> {{'Fraud Analytics' | MMSTranslate}}
            </ng-template>
            <ng-container  *ngIf="dataTransformService.barCodeNum">
              <app-fraud-rules [IO]="payloadInEdit" [transactionState]="mapperTransactionState"
              [barcodeNum]='dataTransformService.barCodeNum'>
              </app-fraud-rules>
            </ng-container>
            <nz-skeleton *ngIf="!dataTransformService.barCodeNum" [nzAvatar]="false" [nzActive]="true"
              [nzLoading]="!dataTransformService.barCodeNum"></nz-skeleton>
      
          </nz-tab> -->

            <!-- Nominee/Beneficiary  DETAILS -->
            <!-- <nz-tab [nzTitle]="titleTmplLifeIns" *ngIf="getTabVisibilityStatus('NomineeDetails')">
            <ng-template #titleTmplLifeIns>
              <i nz-icon nzType="heart"></i> Nominee/Beneficiary
            </ng-template>
            <div [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw'">
              //Nominee
              <app-captured-client-list captureRole="NOMINEE" (clientEmitterToCopy)="updateClientList($event,'NOMINEE')"
                [allowClientToBeCopied]="FALSEVALUE" [operationMode]="MULTI" [clientList]="nomineeDataSet"
                [enableSplitPercentage]="TRUEVALUE" [allowedCount]="noOfClientsCanBeAdded.NOM"
                [enableClientAsPayer]="FALSEVALUE" (openSearchModal)="editClient('modSearchNominee', $event)"
                [allowClientToBeInsuredOwner]="TRUEVALUE"
                (componentOutput)="_BaseEmitHandler($event, 'CapturedClientListComponentNOMINEE')"
                (emittedClient)="_EmittedClientHandler($event, 'NOMINEE')"
                [inputDataForEdit]="_inputAllClientListComponent">
              </app-captured-client-list>
            </div>
          </nz-tab> -->


            <!-- Payer and Payment Details -->
            <nz-tab [nzTitle]="titleTmplBasicDtl" *ngIf="getTabVisibilityStatus('PaymentDetails')" [nzDisabled]="userRole == 'PROPOSAL_BRANCH_OFFICER'"
              (nzSelect)="log(['select', tab])" (nzClick)="log(['click', tab])" (nzDeselect)="log(['deselect', tab])">
              <ng-template #titleTmplBasicDtl>
                <i nz-icon nzType="credit-card"></i> Payment
              </ng-template>
              <!-- {{copySource | json}} -->
              <div [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw' || mapperTransactionState=='proposal_CounterOffer' || mapperTransactionState=='LIFEproposal_CounterOffer' || disableTransaction">
                <!-- PAYER -->

                <app-client-list *ngIf="componentRefreshFl" [capturedRole]="constants.ROLES.PAYER" [clientMaps]="_inputClientListComponent"
                  (openSearchModal)="editSelectedClient($event, constants.ROLES.PAYER)">
                </app-client-list>

                <!-- <app-multicapture-bank-details [IO]="payloadInEdit" [componentName]="'MulticaptureBankDetailsComponent'" -->
                  <!-- [inputDataForEdit]="_inputMulticaptureBankDetailsComponent" -->
                  <!-- [transactionState]="mapperTransactionState" [bankBeneficiaryRole]="this.setRolesBeneficiary" -->
                  <!-- (componentOutput)="_BaseEmitHandler($event, 'MulticaptureBankDetailsComponent')"> -->
                <!-- </app-multicapture-bank-details> -->

                <!-- <app-multicapture-bank-details  [IO]="payloadInEdit"
                [inputDataForEdit]="_inputMulticaptureBankDetailsComponent" [transactionState]="mapperTransactionState"
                (componentOutput)="_BaseEmitHandler($event, 'MulticaptureBankDetailsComponent')"
                [businessType]="businessType" [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw' || mapperTransactionState='proposal_CounterOffer' || mapperTransactionState='LIFEproposal_CounterOffer' || disableTransaction"
                [class.anchors-are-disabled]="modRejectIntimation || payloadInEdit && payloadInEdit['caseDO'] &&  payloadInEdit['proposalDO'] && payloadInEdit['caseDO']['statusCd'] == 'REJECT' && payloadInEdit['proposalDO']['statusCd'] == 'REJECT'">
                </app-multicapture-bank-details> -->

                <bank-details [showComponent]="claimClientRoles_HM.has('PAYER') && claimClientRoles_HM.get('PAYER').size > 0" [componentName]="'BankDetailsComponent'" [IO]="payloadInEdit" [emitToTransaction]="true"
                  (componentOutput)="_BaseEmitHandler($event, 'BankDetailsComponent')" [transactionState]="mapperTransactionState"
                  [inputDataForEdit]="_inputBankDetailsComponent" [bankBeneficiaryRole]="this.setRolesBeneficiary"(changedField)="getDataOnChange($event)">
                </bank-details>

              </div>

            </nz-tab>

            <!-- Questionaire -->
            <nz-tab [nzTitle]="titleTmplBasicDtl" [nzDisabled]="userRole == 'PROPOSAL_BRANCH_OFFICER'"
              [hidden]="!getTabVisibilityStatus('QuestionaireDetails') && payloadInEdit"
              (nzSelect)="log(['select', tab])" (nzClick)="log(['click', tab])" (nzDeselect)="log(['deselect', tab])">
              <ng-template #titleTmplBasicDtl>
                <i nz-icon nzType="question-circle"></i> Questionnaire
              </ng-template>
              <div *ngIf="!appMetadataHandler.featureFlags.enableGenericQuestionnaire"
                [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw' || mapperTransactionState=='proposal_CounterOffer' || mapperTransactionState=='LIFEproposal_CounterOffer' || disableTransaction">
                <app-proposal-questionnaire (componentOutput)="_BaseEmitHandler($event, 'QuestionnaireComponent')"
                  [IO]="payloadInEdit"></app-proposal-questionnaire>
              </div>

              <!-- [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw'" -->
              <div *ngIf="appMetadataHandler.featureFlags.enableGenericQuestionnaire">
                <app-questionnaire *ngIf="refreshThisComponenetOnSaveSubmit"
                 [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw' || mapperTransactionState=='proposal_CounterOffer' || mapperTransactionState=='LIFEproposal_CounterOffer' || disableTransaction"
                  (componentOutput)="_BaseEmitHandler($event, 'QuestionnaireComponent')"
                  [inputDataForEdit]="payloadInEdit" (changedField)="getDataOnChange($event)">
                </app-questionnaire>
              </div>
            </nz-tab>

            <!-- Premium -->
            <nz-tab [nzTitle]="titleTmplBasicDtl" [nzDisabled]="userRole == 'PROPOSAL_BRANCH_OFFICER'"
              *ngIf="getTabVisibilityStatus('PaymentBreakupDetails') && payloadInEdit" (nzSelect)="log(['select', tab])"
              (nzClick)="log(['click', tab])" (nzDeselect)="log(['deselect', tab])">
              <ng-template #titleTmplBasicDtl>
                <i nz-icon nzType="file-done"></i> Premium
              </ng-template>
              <div [class.inputs-are-disabled]="mapperTransactionState=='proposal_CounterOffer' || mapperTransactionState=='LIFEproposal_CounterOffer' || disableTransaction">
                <app-payment-breakup *ngIf="refreshThisComponenetOnSaveSubmit"
                  (componentOutput)="_BaseEmitHandler($event, 'PaymentBreakupDetails')"
                  [inputDataForEdit]="payloadInEdit" (changedField)="getDataOnChange($event)">
                </app-payment-breakup>
              </div>
            </nz-tab>

            <!-- Agent Details -->
            <nz-tab [nzTitle]="titleTmplBasicDtl" *ngIf="getTabVisibilityStatus('AgentDetails')" [nzDisabled]="userRole == 'PROPOSAL_BRANCH_OFFICER'"
              (nzSelect)="log(['select', tab])" (nzClick)="log(['click', tab])" (nzDeselect)="log(['deselect', tab])">
              <ng-template #titleTmplBasicDtl>
                <i nz-icon nzType="file-text"></i> Intermediary
              </ng-template>
              <ng-container>
            <app-captured-agent-list [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw'"  class captureRole="Intermediary Details" [agentList]="agentDataSet"
                  [transactionState]="mapperTransactionState"
                  (componentOutput)="_BaseEmitHandler($event, 'CapturedAgentListComponent')"
                  (openModal)="modSearchAgent=true" [inputDataForEdit]="_inputAgentListComponent" (changedField)="getDataOnChange($event)">
                </app-captured-agent-list>
              </ng-container>
            </nz-tab>

            <!-- Other Policy -->
            <nz-tab [nzTitle]="titleTmplBasicDtl" *ngIf="getTabVisibilityStatus('OtherPolicyComponent')" [nzDisabled]="userRole == 'PROPOSAL_BRANCH_OFFICER'"
              (nzSelect)="log(['select', tab])" (nzClick)="log(['click', tab])" (nzDeselect)="log(['deselect', tab])">
              <ng-template #titleTmplBasicDtl>
                <i nz-icon nzType="file-text"></i> Other Policies
              </ng-template>
              <div
                *ngIf="productFamilyCd == 'HEALTH' && appMetadataHandler.featureFlags.showOtherPoliciesGrid" >
                <!-- *ngIf="appMetadataHandler['allowedLOB'] == 'HEALTH' && appMetadataHandler.featureFlags.showOtherPoliciesGrid"> -->
                
                <div *ngIf="mapperTransactionState ==='proposal_DataEntry' || mapperTransactionState ==='MOTORproposal_DataEntry'
                || mapperTransactionState ==='TRAVELproposal_DataEntry' || mapperTransactionState ==='PROPERTYproposal_DataEntry' ">
                  <app-input-grid-nested [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw' || disableTransaction"
                    [FORMNAME]="'otherPoliciesParentForm'"
                    [CHILDGRIDFORM]="otherPoliciesChildForm"
                    [componentMetaData]="configData.ComponentMetaDataConfiguration.OtherPoliciesComponentNB"
                    (componentOutput)="_BaseEmitHandler($event, 'OtherPolicyComponent')"
                    [transactionState]="mapperTransactionState" [currentComponent]="'OtherPolicyComponent'"
                    [IO]="payloadInEdit">
                  </app-input-grid-nested>
                </div>
                <div *ngIf="mapperTransactionState ==='proposal_ManualUw'|| mapperTransactionState ==='MOTORproposal_ManualUw'
                ||mapperTransactionState ==='TRAVELproposal_ManualUw' || mapperTransactionState ==='PROPERTYproposal_ManualUw'">
                  <app-input-grid-nested [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw' || disableTransaction"
                    [componentMetaData]="configData.ComponentMetaDataConfiguration.OtherPoliciesComponentUW"
                    [FORMNAME]="'otherPoliciesParentForm'"
                    [CHILDGRIDFORM]="otherPoliciesChildForm"
                    (componentOutput)="_BaseEmitHandler($event, 'OtherPolicyComponent')"
                    [transactionState]="mapperTransactionState" [currentComponent]="'OtherPolicyComponent'"
                    [IO]="payloadInEdit">
                  </app-input-grid-nested>
                </div>
              </div>
              <div *ngIf="productFamilyCd == 'LIFE' && appMetadataHandler.featureFlags.showOtherPoliciesGrid">
                <div *ngIf="mapperTransactionState ==='LIFEproposal_DataEntry'">
                  <app-input-grid-nested
                    [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw' || disableTransaction"
                    [componentMetaData]="configData.ComponentMetaDataConfiguration.OtherPoliciesComponentNB_LIFE"
                    [FORMNAME]="'otherPoliciesParentForm'"
                    [CHILDGRIDFORM]="otherPoliciesChildForm"
                    (componentOutput)="_BaseEmitHandler($event, 'OtherPolicyComponent')" [transactionState]="mapperTransactionState"
                    [currentComponent]="'OtherPolicyComponent'" [IO]="payloadInEdit">
                  </app-input-grid-nested>
                </div>
                <div *ngIf="mapperTransactionState ==='proposal_ManualUw' || mapperTransactionState ==='LIFEproposal_ManualUw'">
                  <app-input-grid-nested  
                    [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw' || disableTransaction"
                    [componentMetaData]="configData.ComponentMetaDataConfiguration.OtherPoliciesComponentUW_LIFE"
                    [FORMNAME]="'otherPoliciesParentForm'"
                    [CHILDGRIDFORM]="otherPoliciesChildForm"
                    (componentOutput)="_BaseEmitHandler($event, 'OtherPolicyComponent')" [transactionState]="mapperTransactionState"
                    [currentComponent]="'OtherPolicyComponent'" [IO]="payloadInEdit">
                  </app-input-grid-nested>
                </div>
              </div>
            </nz-tab>

            <!-- Follow Up Screen -->
            <nz-tab [nzTitle]="titleTmplFollowUpScreen" *ngIf="hideTab" (nzSelect)="log(['select', tab])" (nzClick)="log(['click', tab])" (nzDeselect)="log(['deselect', tab])">
              <ng-template #titleTmplFollowUpScreen>
                <i nz-icon nzType="file-text"></i> Follow Up
              </ng-template>
              <div>
                <app-input-grid-nested [componentMetaData]="configData.ComponentMetaDataConfiguration.followUpComponent"
                [transactionState]="mapperTransactionState" [currentComponent]="'followUpComponent'"
                  [IO]="payloadInEdit">
                </app-input-grid-nested>
              </div>
            </nz-tab>

              <!-- Collaboration -->
            <nz-tab [nzTitle]="titleTmplFollowUp" *ngIf="getTabVisibilityStatus('Collaboration')">
              <ng-template #titleTmplFollowUp>
                <i nz-icon nzType="message"></i> {{'Collaboration' | MMSTranslate}}
              </ng-template>
            
              <app-collaboration [IO]="payloadInEdit" [inputDataForEdit]="collaborationList"
                [transactionState]="mapperTransactionState"
                (componentOutput)="_BaseEmitHandler($event, 'CollaborationComponent')"></app-collaboration>
            
            </nz-tab>

            <!-- Receipting -->
            <nz-tab [nzTitle]="titleTmplReceipting" (nzSelect)="log(['select', tab])" (nzClick)="log(['click', tab])" [nzDisabled]="userRole == 'PROPOSAL_BRANCH_OFFICER'"
              (nzDeselect)="log(['deselect', tab])">
              <ng-template #titleTmplReceipting>
                <i nz-icon nzType="file-done"></i> Receipting
              </ng-template>
              <div>
                <app-receipting [viewFromTab]='true' [configData]="configData" 
                  [transactionState]="mapperTransactionState" [IO]="payloadInEdit" 
                  (componentOutput)="_BaseEmitHandler($event, 'ReceiptingComponent')" (changedField)="getDataOnChange($event)"></app-receipting>
              </div>
            </nz-tab>

          


           
            

            <!-- Medical Risk -->
            <!-- <nz-tab [nzTitle]="titleTmplMedicalRisk"
            (nzSelect)="log(['select', tab])" (nzClick)="log(['click', tab])" (nzDeselect)="log(['deselect', tab])">
            <ng-template #titleTmplMedicalRisk>
              <i nz-icon nzType="file-done"></i> Medical Risk
            </ng-template>
            <div>
              <app-medical-risk></app-medical-risk>
            </div>
          </nz-tab> -->



            <!-- Vehicle Details -->
            <ng-container *ngIf="this.tempInVisible;">

              <nz-tab [nzTitle]="titleTmplBasicDtl" *ngIf="getTabVisibilityStatus('VehicleDetails')"
                (nzSelect)="log(['select', tab])" (nzClick)="log(['click', tab])" (nzDeselect)="log(['deselect', tab])">
                <ng-template #titleTmplBasicDtl>
                  <i nz-icon nzType="file-text"></i> Vehicle Details
                </ng-template>
                <div [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw'">
                  <app-generic-zero-ui [list]="this.tempAgentDetail"></app-generic-zero-ui>
                </div>
              </nz-tab>
            </ng-container>

            <!-- Trip -->
            <ng-container *ngIf="this.tempInVisible;">

              <nz-tab [nzTitle]="titleTmplBasicDtl" *ngIf="getTabVisibilityStatus('TripDetails')"
                (nzSelect)="log(['select', tab])" (nzClick)="log(['click', tab])" (nzDeselect)="log(['deselect', tab])">
                <ng-template #titleTmplBasicDtl>
                  <i nz-icon nzType="file-text"></i> Trip
                </ng-template>
                <div [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw'">
                  <app-generic-zero-ui [list]="this.tempAgentDetail"></app-generic-zero-ui>
                </div>
              </nz-tab>
            </ng-container>

            <!-- Property -->
            <ng-container *ngIf="this.tempInVisible;">

              <nz-tab [nzTitle]="titleTmplBasicDtl" *ngIf="getTabVisibilityStatus('PropertyDetails')"
                (nzSelect)="log(['select', tab])" (nzClick)="log(['click', tab])" (nzDeselect)="log(['deselect', tab])">
                <ng-template #titleTmplBasicDtl>
                  <i nz-icon nzType="file-text"></i> Property
                </ng-template>
                <div [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw'">
                  <app-generic-zero-ui [list]="this.tempAgentDetail"></app-generic-zero-ui>
                </div>
              </nz-tab>
            </ng-container>

            <!-- Claim Decision added by Abhishek -->
            <!-- <nz-tab [nzTitle]="titleTmplUWDecision" *ngIf="getTabVisibilityStatus('ClaimDecision')">
          <ng-template #titleTmplUWDecision>
            <i nz-icon nzType="exception"></i> Final Underwriting Decision
          </ng-template>
          <app-underwriting-decision [inputDataForEdit]="_inputClaimDecisionComponent"
            [transactionState]="mapperTransactionState"
            (componentOutput)="_BaseEmitHandler($event, 'UnderwritingDecisionComponent')"
            [DOName]="_getDOName(mapperTransactionState)"></app-underwriting-decision>
        </nz-tab> -->

          </nz-tabset>

          <ng-template #toggleView>
        <nz-switch nzSize="small" [(ngModel)]="viewType" (ngModelChange)="setDataView($event)"
        [nzCheckedChildren]="checkedTemplate" [nzUnCheckedChildren]="unCheckedTemplate"></nz-switch>
      <ng-template #checkedTemplate><span nz-icon nzType="table" nz-tooltip
          nzTooltipTitle="Grid View"></span></ng-template>
      <ng-template #unCheckedTemplate><span nz-icon nzType="unordered-list" nz-tooltip
          nzTooltipTitle="List View"></span></ng-template>
      </ng-template>

      
          <!-- Integration -->
          <nz-tabset *ngIf="isEditWithConfig">
            <ng-container *ngFor="let tab of tabsets">
              <nz-tab [nzTitle]="tabTitleTemplate">
                <ng-template #tabTitleTemplate>
                  <i nz-icon [nzType]="tab.icon"></i> {{tab.name}}
                </ng-template>
                <ng-container *ngFor="let section of tab.sections">
                  <!-- <pre>{{tab.sections | json}}</pre> -->
                  <ng-container [ngSwitch]="section.type">
                    <ng-container *ngSwitchCase="'form'">
                      <app-dynamic-form *ngIf="refreshComponentToggle" baseDOName="proposalDO"
                        [FORMTITLE]="section.heading" [FORMNAME]="section.controlId"
                        [currentComponentName]="section.controlId"
                        [(ngModel)]="currentAllComponentData[section.controlId]" [emitComponentDataInNgModel]="true"
                        [dynamicRenderingMode]="true" [formMetaData]="section.formItems" [IO]="payloadInEdit">
                      </app-dynamic-form>
                    </ng-container>
                    <ng-container *ngSwitchCase="'editable-grid'">
                      <!-- <span style="color: red;">Section type received in config not yet supported</span> -->
                      <app-light-grid *ngIf="refreshComponentToggle" [metaDataConfig]="section"
                        [(ngModel)]="currentAllComponentData[section.controlId]"
                        [currentComponentName]="section.controlId" [IO]="payloadInEdit">
                      </app-light-grid>
                      <!-- <app-input-grid-nested [componentMetaData]="section" [transactionState]="mapperTransactionState"
                      [currentComponent]="section.controlId" [IO]="payloadInEdit"
                      (componentOutput)="_BaseEmitHandler($event, section.controlId)"></app-input-grid-nested> -->
                    </ng-container>
                    <ng-container *ngSwitchCase="'light-grid'">
                      <app-light-grid [metaDataConfig]="section" [(ngModel)]="payloadInEdit">
                      </app-light-grid>
                    </ng-container>
                    <ng-container *ngSwitchCase="'client-handling-component'">                      
                      <app-enlist-client-records [config]="section" [IO]="payloadInEdit"></app-enlist-client-records>
                    </ng-container>
                    <ng-container *ngSwitchCase="'custom-component'">
                      <ng-container *ngFor="let component of section.formItems">
                        <ng-container [ngSwitch]="component.fieldKey">

                          <ng-container *ngSwitchCase="'RulesAutoComponent_UWRules'">
                            <app-rules-auto *ngIf="payloadInEdit" [IO]="payloadInEdit"></app-rules-auto>
                          </ng-container>

                          <ng-container *ngSwitchCase="'PaymentBreakupComponent'">
                            <app-payment-breakup *ngIf="refreshThisComponenetOnSaveSubmit"
                              (componentOutput)="_BaseEmitHandler($event, 'PaymentBreakupDetails')"
                              [inputDataForEdit]="payloadInEdit">
                            </app-payment-breakup>
                          </ng-container>

                          <ng-container *ngSwitchCase="'CapturedClientListComponent_PAYER'">
                            <div [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw'"
                              *ngIf="refreshPayerFlag">
                              <!-- PAYER -->
                              <!-- {{copySourceForClaimant | json}} -->
                              <!-- <app-captured-client-list [configData]="configData" captureRole="PAYER" [operationMode]="MULTI"
                                [clientList]="payerDataSet" [allowEditInsured]="FALSEVALUE"
                                (openSearchModal)="editClient('modSearchCustomerPayer', $event)"
                                [copySource]="copySourceForClaimant" [enableClientAsPayer]="FALSEVALUE"
                                [allowedCount]="noOfClientsCanBeAdded.PAY" [transactionState]="mapperTransactionState"
                                (componentOutput)="_BaseEmitHandler($event, 'CapturedClientListComponentPAYER')"
                                (updateClientList)="updateClientList($event,'PAYER')"
                                [inputDataForEdit]="_inputAllClientListComponent">
                              </app-captured-client-list> -->

                              <!-- <app-multicapture-bank-details [IO]="payloadInEdit"
                                [inputDataForEdit]="_inputMulticaptureBankDetailsComponent"
                                [transactionState]="mapperTransactionState"
                                [bankBeneficiaryRole]="this.setRolesBeneficiary"
                                (componentOutput)="_BaseEmitHandler($event, 'MulticaptureBankDetailsComponent')">
                              </app-multicapture-bank-details> -->

                              <bank-details [showComponent]="claimClientRoles_HM.has('PAYER') && claimClientRoles_HM.get('PAYER').size > 0" [componentName]="'BankDetailsComponent'" [IO]="payloadInEdit" [emitToTransaction]="true"
                              (componentOutput)="_BaseEmitHandler($event, 'BankDetailsComponent')" [transactionState]="mapperTransactionState"
                              [inputDataForEdit]="_inputBankDetailsComponent" [bankBeneficiaryRole]="this.setRolesBeneficiary"(changedField)="getDataOnChange($event)">
                            </bank-details>

                            </div>
                          </ng-container>

                          <ng-container *ngSwitchCase="'SubmissionDataComponent'">
                            <div [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw' || disableTransaction">

                              <app-submission-data [inputDataForEdit]="_inputSubmissionDataComponent"
                                [DOName]="_getDOName(TransactionState)" [transactionState]="mapperTransactionState"
                                [proposalType]="proposalType" [configData]="configData" [product]="selectedProduct"
                                [productFamilyCd]="productFamilyCd" (policyPackageType)="getPackageType($event)" (changedField)="getDataOnChange($event)"
                                (componentOutput)="_BaseEmitHandler($event, 'SubmissionDataComponent')">
                              </app-submission-data>

                            </div>
                          </ng-container>
                          <!-- <ng-container *ngSwitchCase="'CapturedClientListComponent_OWNER'">
                            <div [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw' || disableTransaction">
                              
                              <app-captured-client-list [configData]="configData" captureRole="OWNER"
                                (clientEmitterToCopy)="updateClientList($event,'OWNER')"
                                [allowClientToBeCopied]="TRUEVALUE" [allowEditInsured]="FALSEVALUE"
                                [operationMode]="SINGLE" [clientList]="ownerDataSet" [enableClientAsPayer]="TRUEVALUE"
                                [addNominee]="true" (openSearchModal)="editClient('modSearchCustomerOwner', $event)"
                                [transactionState]="mapperTransactionState" [allowedCount]="noOfClientsCanBeAdded.PH"
                                (componentOutput)="_BaseEmitHandler($event, 'CapturedClientListComponentOWNER')"
                                (emittedClient)="_EmittedClientHandler($event, 'PRIMARYINSURED')"
                                [inputDataForEdit]="_inputAllClientListComponent">
                              </app-captured-client-list>
                            </div>
                          </ng-container> -->
                          <!-- <app-client-list [capturedRole]="constants.ROLES.OWNER" [clientMaps]="_inputAllClientListComponent"
                            (openSearchModal)="editSelectedClient($event, capturedRole)">
                          </app-client-list> -->

                          <ng-container *ngSwitchCase="'CapturedClientListComponent_PRIMARYINSURED'">
                            <div [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw' || disableTransaction"
                              *ngIf="refreshPrimaryInsuredFlag">
                              <!-- Primary Insured -->
                              <!-- <app-captured-client-list [configData]="configData" captureRole="PRIMARYINSURED"
                                (updateClientList)="updateClientList($event,'PRIMARYINSURED')" [operationMode]="SINGLE"
                                [clientList]="primaryInsuredDataSet" [allowedCount]="noOfClientsCanBeAdded.PI"
                                [enableClientAsPayer]="FALSEVALUE" [addNominee]="true"
                                (openSearchModal)="editClient('modSearchCustomerPrimaryInsured', $event)"
                                [transactionState]="mapperTransactionState"
                                (componentOutput)="_BaseEmitHandler($event, 'CapturedClientListComponentPRIMARYINSURED')"
                                [inputDataForEdit]="_inputAllClientListComponent">
                              </app-captured-client-list> -->
                            </div>
                          </ng-container>

                          <!-- <ng-container *ngSwitchCase="'CapturedClientListComponent_INSURED'">
                            <div [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw' || disableTransaction">
                              <app-captured-client-list [configData]="configData" captureRole="INSURED"
                                (clientEmitterToCopy)="updateClientList($event,'INSURED')"
                                [allowClientToBePrimaryInsured]="FALSEVALUE" [allowedCount]="noOfClientsCanBeAdded.IN"
                                [enableClientAsPayer]="FALSEVALUE" [addNominee]="true"
                                [allowClientToCaptureRelationship]="FALSEVALUE" [operationMode]="MULTI"
                                [clientList]="insuredDataSet"
                                (openSearchModal)="editClient('modSearchCustomerInsured', $event)"
                                [transactionState]="mapperTransactionState"
                                (componentOutput)="_BaseEmitHandler($event, 'CapturedClientListComponentINSURED')"
                                [inputDataForEdit]="_inputAllClientListComponent">
                              </app-captured-client-list>
                            </div>
                          </ng-container> -->
                          <ng-container *ngSwitchCase="'CapturedClientListComponent_NOMINEE'">
                            <div [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw' || disableTransaction">
                              <!--  Nominee -->
                              <!-- <app-captured-client-list [configData]="configData" captureRole="NOMINEE"
                                (clientEmitterToCopy)="updateClientList($event,'NOMINEE')"
                                [allowClientToBeCopied]="FALSEVALUE" [operationMode]="MULTI"
                                [clientList]="nomineeDataSet" [enableSplitPercentage]="TRUEVALUE"
                                [allowedCount]="noOfClientsCanBeAdded.NOM" [enableClientAsPayer]="FALSEVALUE"
                                (openSearchModal)="editClient('modSearchNominee', $event)"
                                [transactionState]="mapperTransactionState" [allowClientToBeInsuredOwner]="TRUEVALUE"
                                (componentOutput)="_BaseEmitHandler($event, 'CapturedClientListComponentNOMINEE')"
                                (emittedClient)="_EmittedClientHandler($event, 'NOMINEE')"
                                [inputDataForEdit]="_inputAllClientListComponent" [IO]="payloadInEdit">
                              </app-captured-client-list> -->
                            </div>
                          </ng-container>
                          <ng-container *ngSwitchCase="'CapturedClientListComponent_APPOINTEE'">
                            <div [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw' || disableTransaction">
                              <div [hidden]="appMetadataHandler['LOB'] != 'LIFE'">
                                <!-- <app-captured-client-list [configData]="configData" captureRole="APPOINTEE"
                                  (clientEmitterToCopy)="updateClientList($event,'APPOINTEE')"
                                  [allowClientToBeCopied]="FALSEVALUE" [operationMode]="MULTI"
                                  [clientList]="appointeeDataSet" [allowedCount]="noOfClientsCanBeAdded.NOM"
                                  [enableClientAsPayer]="FALSEVALUE"
                                  (openSearchModal)="editClient('modSearchAppointee', $event)"
                                  [transactionState]="mapperTransactionState" [allowClientToBeInsuredOwner]="TRUEVALUE"
                                  (componentOutput)="_BaseEmitHandler($event, 'CapturedClientListComponentAPPOINTEE')"
                                  (emittedClient)="_EmittedClientHandler($event, 'APPOINTEE')"
                                  [inputDataForEdit]="_inputAllClientListComponent">
                                </app-captured-client-list> -->
                              </div>
                            </div>
                          </ng-container>

                          <ng-container *ngSwitchCase="'ProductCoveragesComponent'">
                            <div *ngIf="!refreshThisComponenetOnSaveSubmit"
                              style="display:block;border: 1px solid #dedede; padding: 40px; text-align:center;line-height: 1.5rem;color: #999">
                              Saving coverages and calculating premium
                            </div>

                            <nz-skeleton *ngIf="!refreshThisComponenetOnSaveSubmit" [nzAvatar]="false" [nzActive]="true"
                              [nzTitle]="true" [nzLoading]="!refreshThisComponenetOnSaveSubmit">
                            </nz-skeleton>
                            <div>
                              <app-product-coverages *ngIf="refreshThisComponenetOnSaveSubmit"
                                (componentOutput)="_BaseEmitHandler($event, 'ProductCoveragesComponent')"
                                (basePlanComponentOutput)="_BaseEmitHandler($event, 'BasePlanComponent')"
                                [product]="selectedProduct" [configData]="configData"
                                [transactionState]="mapperTransactionState" [transformType]="productFamilyCd"
                                [inputDataForEdit]="payloadInEdit" title="Base Plan" ExtractPlanTypeCd="RIDER">
                              </app-product-coverages>
                            </div>
                          </ng-container>
                          <ng-container *ngSwitchCase="'DECISIONBREAKUP'">
                             <ng-container *ngIf="appMetadataHandler.featureFlags.enableSingleDecisionOnDecisionBreakup">
                               <app-decision [configData]="configData" [DOName]="_getDOName(mapperTransactionState)" [inputDataForEdit]="_inputInsuredCoverageDecisionComponent"
                                  [transactionState]="mapperTransactionState"
                                  (componentOutputForDecisionForm) = "_BaseEmitHandler($event, 'ProposalDecisionComponent')"
                                  (componentOutputForCovergaeDecision) = "_BaseEmitHandler($event, 'CoverageDecisionComponent')">
                                </app-decision>
                            </ng-container>

                            <!-- Even If decision for Policy is selected all other decisions are visible -->
                            <ng-container
                              *ngIf="!appMetadataHandler.featureFlags.enableSingleDecisionOnDecisionBreakup">
                               <app-decision [configData]="configData" [DOName]="_getDOName(mapperTransactionState)" [inputDataForEdit]="_inputInsuredCoverageDecisionComponent"
                                  [transactionState]="mapperTransactionState"
                                  (componentOutputForDecisionForm) = "_BaseEmitHandler($event, 'ProposalDecisionComponent')"
                                  (componentOutputForCovergaeDecision) = "_BaseEmitHandler($event, 'CoverageDecisionComponent')">
                                </app-decision>
                              
                            </ng-container>

                          </ng-container>
                          <ng-container *ngSwitchCase="'QUESTIONNAIRE'">
                            <div *ngIf="!appMetadataHandler.featureFlags.enableGenericQuestionnaire"
                              [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw' || disableTransaction">
                              <app-proposal-questionnaire
                                (componentOutput)="_BaseEmitHandler($event, 'QuestionnaireComponent')"
                                [IO]="payloadInEdit"></app-proposal-questionnaire>
                            </div>

                            <!-- [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw'" -->
                            <div *ngIf="appMetadataHandler.featureFlags.enableGenericQuestionnaire">
                              <app-questionnaire *ngIf="refreshThisComponenetOnSaveSubmit"
                                (componentOutput)="_BaseEmitHandler($event, 'QuestionnaireComponent')"
                                [inputDataForEdit]="payloadInEdit">
                              </app-questionnaire>
                            </div>
                          </ng-container>
                          <ng-container *ngSwitchCase="'INTERMEDIARYDETAILS'">
                            <app-captured-agent-list captureRole="Intermediary Details" [agentList]="agentDataSet"
                              [transactionState]="mapperTransactionState"
                              (componentOutput)="_BaseEmitHandler($event, 'CapturedAgentListComponent')"
                              (openModal)="modSearchAgent=true" [inputDataForEdit]="_inputAgentListComponent">
                            </app-captured-agent-list>
                          </ng-container>
                          <ng-container *ngSwitchCase="'OTHERPOLICIES'">
                            <div
                              *ngIf="productFamilyCd == 'HEALTH' && appMetadataHandler.featureFlags.showOtherPoliciesGrid">
                              <div *ngIf="mapperTransactionState ==='proposal_DataEntry'">
                                <app-input-grid-nested
                                  [FORMNAME]="'otherPoliciesParentForm'"
                                  [CHILDGRIDFORM]="otherPoliciesChildForm"
                                  [componentMetaData]="configData.ComponentMetaDataConfiguration.OtherPoliciesComponentNB"
                                  (componentOutput)="_BaseEmitHandler($event, 'OtherPolicyComponent')"
                                  [transactionState]="mapperTransactionState"
                                  [currentComponent]="'OtherPolicyComponent'" [IO]="payloadInEdit">
                                </app-input-grid-nested>
                              </div>
                              <div *ngIf="mapperTransactionState ==='proposal_ManualUw'">
                                <app-input-grid-nested
                                  [FORMNAME]="'otherPoliciesParentForm'"
                                  [CHILDGRIDFORM]="otherPoliciesChildForm"
                                  [componentMetaData]="configData.ComponentMetaDataConfiguration.OtherPoliciesComponentUW"
                                  (componentOutput)="_BaseEmitHandler($event, 'OtherPolicyComponent')"
                                  [transactionState]="mapperTransactionState"
                                  [currentComponent]="'OtherPolicyComponent'" [IO]="payloadInEdit">
                                </app-input-grid-nested>
                              </div>
                            </div>
                            <div
                              *ngIf="productFamilyCd == 'LIFE' && appMetadataHandler.featureFlags.showOtherPoliciesGrid">
                              <div *ngIf="mapperTransactionState ==='proposal_DataEntry'">
                                <app-input-grid-nested
                                  [FORMNAME]="'otherPoliciesParentForm'"
                                  [CHILDGRIDFORM]="otherPoliciesChildForm"
                                  [componentMetaData]="configData.ComponentMetaDataConfiguration.OtherPoliciesComponentNB_LIFE"
                                  (componentOutput)="_BaseEmitHandler($event, 'OtherPolicyComponent')"
                                  [transactionState]="mapperTransactionState"
                                  [currentComponent]="'OtherPolicyComponent'" [IO]="payloadInEdit">
                                </app-input-grid-nested>
                              </div>
                              <div *ngIf="mapperTransactionState ==='proposal_ManualUw' || mapperTransactionState ==='LIFEproposal_ManualUw'">
                                <app-input-grid-nested
                                  [FORMNAME]="'otherPoliciesParentForm'"
                                  [CHILDGRIDFORM]="otherPoliciesChildForm"
                                  [componentMetaData]="configData.ComponentMetaDataConfiguration.OtherPoliciesComponentUW_LIFE"
                                  (componentOutput)="_BaseEmitHandler($event, 'OtherPolicyComponent')"
                                  [transactionState]="mapperTransactionState"
                                  [currentComponent]="'OtherPolicyComponent'" [IO]="payloadInEdit">
                                </app-input-grid-nested>
                              </div>
                            </div>
                          </ng-container>
                          <ng-container *ngSwitchCase="'FOLLOWUP'">
                            <div>
                              <app-input-grid-nested
                                [componentMetaData]="configData.ComponentMetaDataConfiguration.followUpComponent"
                                (componentOutput)="_BaseEmitHandler($event, 'followUpComponent')"
                                [transactionState]="mapperTransactionState" [currentComponent]="'followUpComponent'"
                                [IO]="payloadInEdit">
                              </app-input-grid-nested>
                            </div>
                          </ng-container>
                          <ng-container *ngSwitchCase="'RECEIPTING'">
                            <div>
                              <app-receipting [viewFromTab]='true'></app-receipting>
                            </div>
                          </ng-container>

                        </ng-container>
                      </ng-container>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </nz-tab>
            </ng-container>
          </nz-tabset>

        </div>

        <div class="m-t-20" *ngIf="dataView == 'list-layout'">

            <div *ngIf="!isEditWithConfig">
            <div *ngIf="hideTab">
              <nz-collapse [nzBordered]="false" class="panel-custom-unified">
                <nz-collapse-panel [nzActive]="true" [nzHeader]="titleTmplBasicDtl" [ngStyle]="panelCustomStyle"
                  [nzExpandedIcon]="panelIcon||undefined">
                  <ng-template #titleTmplBasicDtl>
                    <div class="heading-tab panel-custom-unified-collapse-heading">
                      <h3 class="heading"><i nz-icon nzType="file-protect"></i> Proposal Review</h3>
                    </div>
                  </ng-template>
                  <div [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw' || disableTransaction">
                    <app-underwriter-review [inputDataForEdit]="_inputAllClientListComponent" [configData]="configData"
                    [transactionState]="mapperTransactionState" (emitStepToEnable)="enableStep($event)" [policyData]="payloadInEdit" [RequirementEntityGuid]="transactionGuid">
                    </app-underwriter-review>
                  </div>
                </nz-collapse-panel>
              </nz-collapse>
              
            </div>

            <div *ngIf="getTabVisibilityStatus('BasicDetails')">
              <nz-collapse [nzBordered]="false" class="panel-custom-unified">
                <nz-collapse-panel #p [nzActive]="true" [nzHeader]="titleTmplBasicDtl" [ngStyle]="panelCustomStyle"
                  [nzExpandedIcon]="panelIcon||undefined">
                  <ng-template #titleTmplBasicDtl>
                    <div class="heading-container">
                      <h3 class="heading">
                        <i nz-icon nzType="solution"></i> Basic Details
                      </h3>
                      <nz-switch class="f-r" style="pointer-events: auto;" nzSize="small" [(ngModel)]="viewType"
                        (ngModelChange)="setDataView($event, p)" [nzCheckedChildren]="checkedTemplate"
                        [nzUnCheckedChildren]="unCheckedTemplate"></nz-switch>
                      <ng-template #unCheckedTemplate><span nz-icon nzType="table" nz-tooltip nzTooltipTitle="Grid View"></span></ng-template>
                      <ng-template #checkedTemplate><span nz-icon nzType="unordered-list" nz-tooltip nzTooltipTitle="List View"></span></ng-template>
                    </div>
                  </ng-template>

                  <div class="list-view-margin" [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw' || disableTransaction">
    
                    <app-submission-data [inputDataForEdit]="_inputSubmissionDataComponent"
                      [DOName]="_getDOName(TransactionState)" [transactionState]="mapperTransactionState"
                      [proposalType]="proposalType" [configData]="configData" [product]="selectedProduct"
                      [productFamilyCd]="productFamilyCd" (policyPackageType)="getPackageType($event)"
                      (componentOutput)="_BaseEmitHandler($event, 'SubmissionDataComponent')" (changedField)="getDataOnChange($event)">
                    </app-submission-data>
    
                    <!-- <app-dynamic-form FORMNAME="submissionDataForm" FORMTITLE="Addition Fields" [IO]="payloadInEdit"></app-dynamic-form> -->
                    <!-- Primary Insured -->
                    <!-- <div *ngIf="refreshPayerDetails">
                      <app-captured-client-list [configData]="configData" captureRole="OWNER" (clientEmitterToCopy)="updateClientList($event,'OWNER')" (mouseenter) ="getDataOnChange('PRIMARYINSURED')"
                        [allowClientToBeCopied]="TRUEVALUE" [allowEditInsured]="FALSEVALUE" [operationMode]="SINGLE"
                        [clientList]="ownerDataSet" [enableClientAsPayer]="TRUEVALUE" [addNominee]="true"
                        (openSearchModal)="editClient('modSearchCustomerOwner', $event)"
                        [transactionState]="mapperTransactionState" [allowedCount]="noOfClientsCanBeAdded.PH"
                        (componentOutput)="_BaseEmitHandler($event, 'CapturedClientListComponentOWNER')"
                        (emittedClient)="_EmittedClientHandler($event, 'PRIMARYINSURED')"
                        [inputDataForEdit]="_inputAllClientListComponent">
                      </app-captured-client-list>
                    </div> -->

                    <!-- <app-client-list [capturedRole]="constants.ROLES.OWNER" [clientMaps]="_inputAllClientListComponent" 
                (openSearchModal)="editSelectedClient($event, capturedRole)">
                </app-client-list> -->
                    <!-- <div>
                      <app-document-manager [mode]="'mini'" [requirementCd]="'Health Declaration'"  (mouseenter) ="getDataOnChange('KYC')"
                        heading="KYC For Policy Holder" [requirements]="[]" [inputDataForEdit]="[]"
                        [RequirementEntityGuid]="transactionGuid">
                      </app-document-manager>
                    </div> -->
    
                  </div>
                </nz-collapse-panel>
              </nz-collapse>
              <!-- <div *ngIf="getTabVisibilityStatus('ClaimDecision')">
            <app-underwriting-decision [inputDataForEdit]="_inputClaimDecisionComponent"
              [transactionState]="mapperTransactionState"
              (componentOutput)="_BaseEmitHandler($event, 'UnderwritingDecisionComponent')"
              [DOName]="_getDOName(mapperTransactionState)"></app-underwriting-decision>
          </div> -->
            </div>

            <!-- NOMINEE & CLAIMANT DETAILS  / Policy Roles -->
            <!-- [copySource]="copySourceForClaimant" sourceRole="OWNER" -->
            <div *ngIf="getTabVisibilityStatus('InsuredMembersDetails')">
              <nz-collapse [nzBordered]="false" class="panel-custom-unified">
                <nz-collapse-panel [nzActive]="true" [nzHeader]="titleTmplClaimant" [ngStyle]="panelCustomStyle"
                  [nzExpandedIcon]="panelIcon||undefined">
                  <ng-template #titleTmplClaimant>
                    <div class="heading-tab panel-custom-unified-collapse-heading">
                      <h3 class="heading"><i nz-icon nzType="team"></i> Members</h3>
                    </div>
                  </ng-template>
                  <div class="list-view-margin" [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw' || disableTransaction"
                    *ngIf="refreshPrimaryInsuredFlag">
                    <!-- Primary Insured -->
                    <!-- <app-captured-client-list [configData]="configData" captureRole="PRIMARYINSURED"
                      (updateClientList)="updateClientList($event,'PRIMARYINSURED')" [operationMode]="SINGLE"
                      [clientList]="primaryInsuredDataSet" [allowedCount]="noOfClientsCanBeAdded.PI"
                      [enableClientAsPayer]="FALSEVALUE" [addNominee]="true"
                      (openSearchModal)="editClient('modSearchCustomerPrimaryInsured', $event)"
                      [transactionState]="mapperTransactionState"
                      (componentOutput)="_BaseEmitHandler($event, 'CapturedClientListComponentPRIMARYINSURED')"
                      [inputDataForEdit]="_inputAllClientListComponent">
                    </app-captured-client-list> -->
    
                    <!-- Member -->
                    <!-- <app-captured-client-list [configData]="configData" captureRole="INSURED"
                      (clientEmitterToCopy)="updateClientList($event,'INSURED')"
                      [allowClientToBePrimaryInsured]="FALSEVALUE" [allowedCount]="noOfClientsCanBeAdded.IN"
                      [enableClientAsPayer]="FALSEVALUE" [addNominee]="true" [allowClientToCaptureRelationship]="FALSEVALUE"
                      [operationMode]="MULTI" [clientList]="insuredDataSet"
                      (openSearchModal)="editClient('modSearchCustomerInsured', $event)"
                      [transactionState]="mapperTransactionState"
                      (componentOutput)="_BaseEmitHandler($event, 'CapturedClientListComponentINSURED')"
                      [inputDataForEdit]="_inputAllClientListComponent">
                    </app-captured-client-list> -->
    
                    <!--  Nominee -->
                    <!-- <app-captured-client-list *ngIf="refreshThisComponenetOnSaveSubmit" [configData]="configData" captureRole="NOMINEE"
                      (clientEmitterToCopy)="updateClientList($event,'NOMINEE')" [allowClientToBeCopied]="FALSEVALUE"
                      [operationMode]="MULTI" [clientList]="nomineeDataSet" [enableSplitPercentage]="TRUEVALUE"
                      [allowedCount]="noOfClientsCanBeAdded.NOM" [enableClientAsPayer]="FALSEVALUE"
                      (openSearchModal)="editClient('modSearchNominee', $event)" [transactionState]="mapperTransactionState"
                      [allowClientToBeInsuredOwner]="TRUEVALUE"
                      (componentOutput)="_BaseEmitHandler($event, 'CapturedClientListComponentNOMINEE')"
                      (emittedClient)="_EmittedClientHandler($event, 'NOMINEE')"
                      [inputDataForEdit]="_inputAllClientListComponent" [IO]="payloadInEdit">
                    </app-captured-client-list> -->
    
                    <!--  Appointee -->
                    <div [hidden]="productFamilyCd != 'LIFE'">
                      <!-- <app-captured-client-list [configData]="configData" captureRole="APPOINTEE"
                        (clientEmitterToCopy)="updateClientList($event,'APPOINTEE')" [allowClientToBeCopied]="FALSEVALUE"
                        [operationMode]="MULTI" [clientList]="appointeeDataSet" [allowedCount]="noOfClientsCanBeAdded.NOM"
                        [enableClientAsPayer]="FALSEVALUE" (openSearchModal)="editClient('modSearchAppointee', $event)"
                        [transactionState]="mapperTransactionState" [allowClientToBeInsuredOwner]="TRUEVALUE"
                        (componentOutput)="_BaseEmitHandler($event, 'CapturedClientListComponentAPPOINTEE')"
                        (emittedClient)="_EmittedClientHandler($event, 'APPOINTEE')"
                        [inputDataForEdit]="_inputAllClientListComponent">
                      </app-captured-client-list> -->
                    </div>
  
                  </div>
                </nz-collapse-panel>
              </nz-collapse>
            </div>

            <!-- Coverages -->
            <div *ngIf="getTabVisibilityStatus('Coverages')">
              <nz-collapse [nzBordered]="false" class="panel-custom-unified">
                <nz-collapse-panel [nzActive]="true" [nzHeader]="titleTmplCoverageDtl" [ngStyle]="panelCustomStyle"
                  [nzExpandedIcon]="panelIcon||undefined">
                  <ng-template #titleTmplCoverageDtl>
                    <div class="heading-tab panel-custom-unified-collapse-heading">
                      <h3 class="heading"><i nz-icon nzType="carry-out"></i> Coverages</h3>
                    </div>
                  </ng-template>
                  <div class="list-view-margin">
                    <div *ngIf="!refreshThisComponenetOnSaveSubmit"
                      style="display:block;border: 1px solid #dedede; padding: 40px; text-align:center;line-height: 1.5rem;color: #999">
                      Saving coverages and calculating premium
                    </div>
      
                    <nz-skeleton *ngIf="!refreshThisComponenetOnSaveSubmit" [nzAvatar]="false" [nzActive]="true"
                      [nzTitle]="true" [nzLoading]="!refreshThisComponenetOnSaveSubmit">
                    </nz-skeleton>
                    <div>
                      <app-product-coverages *ngIf="refreshThisComponenetOnSaveSubmit"
                        (componentOutput)="_BaseEmitHandler($event, 'ProductCoveragesComponent')"
                        (basePlanComponentOutput)="_BaseEmitHandler($event, 'BasePlanComponent')" [product]="selectedProduct"
                        [configData]="configData" [transactionState]="mapperTransactionState"
                        [transformType]="productFamilyCd" [inputDataForEdit]="payloadInEdit" title="Base Plan"
                        ExtractPlanTypeCd="RIDER">
                      </app-product-coverages>
                    </div>
                  </div>
                </nz-collapse-panel>
              </nz-collapse>
            </div>

            <!-- InsuredCoverageDecision -->
            <div *ngIf="getTabVisibilityStatus('InsuredCoverageDecision')">
              <nz-collapse [nzBordered]="false" class="panel-custom-unified">
                <nz-collapse-panel [nzActive]="true" [nzHeader]="titleTmplBenefit" [ngStyle]="panelCustomStyle"
                  [nzExpandedIcon]="panelIcon||undefined">
                  <ng-template #titleTmplBenefit>
                    <div class="heading-tab panel-custom-unified-collapse-heading">
                      <h3 class="heading"><i nz-icon nzType="wallet"></i> Decision</h3>
                    </div>
                  </ng-template>
                  <div class="list-view-margin">
                  <!-- If decision for Policy is selected all other decisions are hidden -->
                    <ng-container *ngIf="appMetadataHandler.featureFlags.enableSingleDecisionOnDecisionBreakup">
                      <!-- <app-underwriting-decision [inputDataForEdit]="_inputUnderwritingDecisionComponent"
                    [transactionState]="mapperTransactionState"
                    (selectedDecisionCd)="_fetchSelectedDecisionCdFromUnderwritingDecisionComponent($event)"
                    (componentOutput)="_BaseEmitHandler($event, 'UnderwritingDecisionComponent')"
                    [DOName]="_getDOName(mapperTransactionState)"></app-underwriting-decision> -->
                      <app-dynamic-form [baseDOName]="configData.StateToDOMapper[mapperTransactionState]"
                        FORMTITLE="Underwriting Decision for Policy" FORMNAME="underwritingDecisionForm" [IO]="payloadInEdit"
                        (componentOutput)="_BaseEmitHandler($event, 'DecisionComponent')"
                        [currentComponentName]="'DecisionComponent'"
                        [formMetaData]="configData.ComponentMetaDataConfiguration.DecisionComponent">
                      </app-dynamic-form>
      
                      <app-insured-coverage-decision *ngIf="!selectedDecisionCd"
                        [inputDataForEdit]="_inputInsuredCoverageDecisionComponent" [IO]="payloadInEdit"
                        (componentOutput)="_BaseEmitHandler($event, 'InsuredCoverageDecisionComponent')">
                      </app-insured-coverage-decision>
                    </ng-container>
      
                    <!-- Even If decision for Policy is selected all other decisions are visible -->
                    <ng-container *ngIf="!appMetadataHandler.featureFlags.enableSingleDecisionOnDecisionBreakup">
                      <!-- <app-underwriting-decision [inputDataForEdit]="_inputUnderwritingDecisionComponent"
                    [transactionState]="mapperTransactionState"
                    (componentOutput)="_BaseEmitHandler($event, 'UnderwritingDecisionComponent')"
                    [DOName]="_getDOName(mapperTransactionState)"></app-underwriting-decision> -->
      
                      <app-dynamic-form [baseDOName]="configData.StateToDOMapper[mapperTransactionState]"
                        FORMTITLE="Underwriting Decision for Policy" FORMNAME="underwritingDecisionForm" [IO]="payloadInEdit"
                        [currentComponentName]="'DecisionComponent'" [(ngModel)]="emittedComponentData['DecisionComponent']"
                        (ngModelChange)="manageInsuredAndCoveragesDecisions(emittedComponentData['DecisionComponent']['uwDecisionCd'])"
                        (componentOutput)="_BaseEmitHandler($event, 'DecisionComponent')"
                        [formMetaData]="configData.ComponentMetaDataConfiguration.DecisionComponent">
                      </app-dynamic-form>
      
                      <nz-skeleton *ngIf="!refreshCoveragesDecision" [nzAvatar]="false" [nzActive]="true" [nzTitle]="true"
                        [nzLoading]="!refreshCoveragesDecision">
                      </nz-skeleton>
      
                      <app-insured-coverage-decision *ngIf="refreshCoveragesDecision"
                        [inputDataForEdit]="_inputInsuredCoverageDecisionComponent" [policyDecision]="givenPolicyDecision"
                        [IO]="payloadInEdit" (componentOutput)="_BaseEmitHandler($event, 'InsuredCoverageDecisionComponent')">
                      </app-insured-coverage-decision>
                    </ng-container>
                  </div>
                </nz-collapse-panel>
              </nz-collapse>

            </div>

            <!-- AutoUWRules -->
            <div *ngIf="getTabVisibilityStatus('AutoUWRules') && enableUWTab">
              <nz-collapse [nzBordered]="false" class="panel-custom-unified">
                <nz-collapse-panel [nzActive]="true" [nzHeader]="titleTmplUWRules" [ngStyle]="panelCustomStyle"
                  [nzExpandedIcon]="panelIcon||undefined">
                  <ng-template #titleTmplUWRules>
                    <div class="heading-tab panel-custom-unified-collapse-heading">
                      <h3 class="heading"><i nz-icon nzType="issues-close"></i>Underwriting Rules</h3>
                    </div>
                  </ng-template>
                  <div class="list-view-margin">
                    <app-rules-auto *ngIf="payloadInEdit" [IO]="payloadInEdit"></app-rules-auto>
                  </div>
                </nz-collapse-panel>
              </nz-collapse>
            </div>

            <!-- <nz-tab [nzTitle]="titleTmplPayout" *ngIf="getTabVisibilityStatus('FWA')">
            <ng-template #titleTmplPayout>
             <em nz-icon type="audit"></em> {{'Fraud Analytics' | MMSTranslate}}
            </ng-template>
            <ng-container *ngIf="dataTransformService.barCodeNum && refreshComponentToggle">
              <app-fraud-rules [IO]="payloadInEdit" [transactionState]="mapperTransactionState"
                [barcodeNum]='dataTransformService.barCodeNum'>
              </app-fraud-rules>
            </ng-container>
            <nz-skeleton *ngIf="!dataTransformService.barCodeNum" [nzAvatar]="false" [nzActive]="true"
              [nzLoading]="!dataTransformService.barCodeNum"></nz-skeleton>
      
          </nz-tab> -->
            <!-- <nz-tab [nzTitle]="titleTmplPayout">
            <ng-template #titleTmplPayout>
             <em nz-icon type="audit"></em> {{'Fraud Analytics' | MMSTranslate}}
            </ng-template>
            <ng-container  *ngIf="dataTransformService.barCodeNum">
              <app-fraud-rules [IO]="payloadInEdit" [transactionState]="mapperTransactionState"
              [barcodeNum]='dataTransformService.barCodeNum'>
              </app-fraud-rules>
            </ng-container>
            <nz-skeleton *ngIf="!dataTransformService.barCodeNum" [nzAvatar]="false" [nzActive]="true"
              [nzLoading]="!dataTransformService.barCodeNum"></nz-skeleton>
      
          </nz-tab> -->

            <!-- Nominee/Beneficiary  DETAILS -->
            <!-- <nz-tab [nzTitle]="titleTmplLifeIns" *ngIf="getTabVisibilityStatus('NomineeDetails')">
            <ng-template #titleTmplLifeIns>
              <i nz-icon nzType="heart"></i> Nominee/Beneficiary
            </ng-template>
            <div [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw'">
              //Nominee
              <app-captured-client-list captureRole="NOMINEE" (clientEmitterToCopy)="updateClientList($event,'NOMINEE')"
                [allowClientToBeCopied]="FALSEVALUE" [operationMode]="MULTI" [clientList]="nomineeDataSet"
                [enableSplitPercentage]="TRUEVALUE" [allowedCount]="noOfClientsCanBeAdded.NOM"
                [enableClientAsPayer]="FALSEVALUE" (openSearchModal)="editClient('modSearchNominee', $event)"
                [allowClientToBeInsuredOwner]="TRUEVALUE"
                (componentOutput)="_BaseEmitHandler($event, 'CapturedClientListComponentNOMINEE')"
                (emittedClient)="_EmittedClientHandler($event, 'NOMINEE')"
                [inputDataForEdit]="_inputAllClientListComponent">
              </app-captured-client-list>
            </div>
          </nz-tab> -->


            <!-- Payer and Payment Details -->
            <div *ngIf="getTabVisibilityStatus('PaymentDetails')">
              <nz-collapse [nzBordered]="false" class="panel-custom-unified">
                <nz-collapse-panel [nzActive]="true" [nzHeader]="titleTmplPaymentDtl" [ngStyle]="panelCustomStyle"
                  [nzExpandedIcon]="panelIcon||undefined">
                  <ng-template #titleTmplPaymentDtl>
                    <div class="heading-tab panel-custom-unified-collapse-heading">
                      <h3 class="heading"><i nz-icon nzType="credit-card"></i>Payment</h3>
                    </div>
                  </ng-template>
                  <!-- {{copySource | json}} -->
                  <div class="list-view-margin" [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw' || mapperTransactionState=='proposal_CounterOffer' || mapperTransactionState=='LIFEproposal_CounterOffer' || disableTransaction"
                    *ngIf="refreshPayerFlag">
                    <!-- PAYER -->
                    <!-- {{copySourceForClaimant | json}} -->
                    <app-captured-client-list [configData]="configData" captureRole="PAYER" [operationMode]="MULTI" [clientList]="payerDataSet"
                      [allowEditInsured]="FALSEVALUE" (openSearchModal)="editClient('modSearchCustomerPayer', $event)"
                      [copySource]="copySourceForClaimant" [enableClientAsPayer]="FALSEVALUE"
                      [allowedCount]="noOfClientsCanBeAdded.PAY" [transactionState]="mapperTransactionState"
                      (componentOutput)="_BaseEmitHandler($event, 'CapturedClientListComponentPAYER')"
                      (updateClientList)="updateClientList($event,'PAYER')" (emittedClientList)="updatePayerDetails($event , 'PAYER')"
                      [inputDataForEdit]="_inputAllClientListComponent" (changedField)="getDataOnChange($event)">
                    </app-captured-client-list>

                    <!-- <app-multicapture-bank-details [IO]="payloadInEdit" [componentName]="'MulticaptureBankDetailsComponent'" -->
                      <!-- [inputDataForEdit]="_inputMulticaptureBankDetailsComponent" -->
                      <!-- [transactionState]="mapperTransactionState" [bankBeneficiaryRole]="this.setRolesBeneficiary" -->
                      <!-- (componentOutput)="_BaseEmitHandler($event, 'MulticaptureBankDetailsComponent')"> -->
                    <!-- </app-multicapture-bank-details> -->

                    <bank-details [showComponent]="claimClientRoles_HM.has('PAYER') && claimClientRoles_HM.get('PAYER').size > 0" [componentName]="'BankDetailsComponent'" [IO]="payloadInEdit" [emitToTransaction]="true"
                      (componentOutput)="_BaseEmitHandler($event, 'BankDetailsComponent')" [transactionState]="mapperTransactionState"
                      [inputDataForEdit]="_inputBankDetailsComponent" [bankBeneficiaryRole]="this.setRolesBeneficiary"(changedField)="getDataOnChange($event)">
                    </bank-details>
                  </div>
                </nz-collapse-panel>
              </nz-collapse>
            </div>

            <!-- Questionaire -->
            <div *ngIf="getTabVisibilityStatus('QuestionaireDetails') && payloadInEdit">
              <nz-collapse [nzBordered]="false" class="panel-custom-unified">
                <nz-collapse-panel [nzActive]="true" [nzHeader]="titleTmplQuestionnaireDtl" [ngStyle]="panelCustomStyle"
                  [nzExpandedIcon]="panelIcon||undefined">
                  <ng-template #titleTmplQuestionnaireDtl>
                    <div class="heading-tab panel-custom-unified-collapse-heading">
                      <h3 class="heading"><i nz-icon nzType="question-circle"></i>Questionnaire</h3>
                    </div>
                  </ng-template>
                  <div class="list-view-margin">
                    <div *ngIf="!appMetadataHandler.featureFlags.enableGenericQuestionnaire"
                      [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw' || disableTransaction">
                      <app-proposal-questionnaire (componentOutput)="_BaseEmitHandler($event, 'QuestionnaireComponent')"
                        [IO]="payloadInEdit"></app-proposal-questionnaire>
                    </div>
      
                    <!-- [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw'" -->
                    <div *ngIf="appMetadataHandler.featureFlags.enableGenericQuestionnaire">
                      <app-questionnaire *ngIf="refreshThisComponenetOnSaveSubmit"
                        (componentOutput)="_BaseEmitHandler($event, 'QuestionnaireComponent')"
                        [inputDataForEdit]="payloadInEdit">
                      </app-questionnaire>
                    </div>
                  </div>
                </nz-collapse-panel>
              </nz-collapse>
            </div>

            <!-- Premium -->
            <div *ngIf="getTabVisibilityStatus('PaymentBreakupDetails') && payloadInEdit">
              <nz-collapse [nzBordered]="false" class="panel-custom-unified">
                <nz-collapse-panel [nzActive]="true" [nzHeader]="titleTmplPremBrkupDtl" [ngStyle]="panelCustomStyle"
                  [nzExpandedIcon]="panelIcon||undefined">
                  <ng-template #titleTmplPremBrkupDtl>
                    <div class="heading-tab panel-custom-unified-collapse-heading">
                      <h3 class="heading"><i nz-icon nzType="file-done"></i>Premium</h3>
                    </div>
                  </ng-template>
                  <!-- [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw'" -->
                  <div class="list-view-margin" [class.inputs-are-disabled]="mapperTransactionState=='proposal_CounterOffer' || mapperTransactionState=='LIFEproposal_CounterOffer' || disableTransaction">
                    <app-payment-breakup *ngIf="refreshThisComponenetOnSaveSubmit"
                      (componentOutput)="_BaseEmitHandler($event, 'PaymentBreakupDetails')"
                      [inputDataForEdit]="payloadInEdit" (changedField)="getDataOnChange($event)">
                    </app-payment-breakup>
                  </div>
                </nz-collapse-panel>
              </nz-collapse>
            </div>

            <!-- Agent Details -->
            <div *ngIf="getTabVisibilityStatus('AgentDetails')">
              <nz-collapse [nzBordered]="false" class="panel-custom-unified">
                <nz-collapse-panel [nzActive]="true" [nzHeader]="titleTmplIntermediaryDtl" [ngStyle]="panelCustomStyle"
                  [nzExpandedIcon]="panelIcon||undefined">
                  <ng-template #titleTmplIntermediaryDtl>
                    <div class="heading-tab panel-custom-unified-collapse-heading">
                      <h3 class="heading"><i nz-icon nzType="file-text"></i>Intermediary</h3>
                    </div>
                  </ng-template>
                  <div class="list-view-margin">
                    <!-- <app-captured-client-list captureRole="AGENT" [operationMode]="MULTI" [clientList]="agentDataSet"
                  (componentOutput)="_BaseEmitHandler($event, 'CapturedClientListComponentAGENT')"
                  (openSearchModal)="modSearchAgent=true" (emittedClient)="_EmittedClientHandler($event, 'AGENT')"
                  [inputDataForEdit]="_inputAllClientListComponent">
                </app-captured-client-list> -->
                    <!-- <app-captured-agent-list captureRole="Intermediary Details" [agentList]="agentDataSet"
                      [transactionState]="mapperTransactionState"
                      (componentOutput)="_BaseEmitHandler($event, 'CapturedAgentListComponent')"
                      (openModal)="modSearchAgent=true" [inputDataForEdit]="_inputAgentListComponent">
                    </app-captured-agent-list> -->

                    <app-captured-agent-list [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw'"  class captureRole="Intermediary Details" [agentList]="agentDataSet"
                  [transactionState]="mapperTransactionState"
                  (componentOutput)="_BaseEmitHandler($event, 'CapturedAgentListComponent')"
                  (openModal)="modSearchAgent=true" [inputDataForEdit]="_inputAgentListComponent" (changedField)="getDataOnChange($event)">
                </app-captured-agent-list>
                  </div>
    
                  <!-- <div [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw'">
                <app-generic-zero-ui [list]="this.tempAgentDetail"></app-generic-zero-ui>
              </div> -->
                </nz-collapse-panel>
              </nz-collapse>
            
            </div>

            <!-- Other Policy -->
            <div *ngIf="getTabVisibilityStatus('OtherPolicyComponent')">
              <nz-collapse [nzBordered]="false" class="panel-custom-unified">
                <nz-collapse-panel [nzActive]="true" [nzHeader]="titleTmplOtherPolDtl" [ngStyle]="panelCustomStyle"
                  [nzExpandedIcon]="panelIcon||undefined">
                  <ng-template #titleTmplOtherPolDtl>
                    <div class="heading-tab panel-custom-unified-collapse-heading">
                      <h3 class="heading"><i nz-icon nzType="file-text"></i>Other Policies</h3>
                    </div>
                  </ng-template>
                  <div class="list-view-margin"
                    *ngIf="appMetadataHandler.featureFlags.showOtherPoliciesGrid">
                    <div *ngIf="mapperTransactionState ==='proposal_DataEntry'">
                      <app-input-grid-nested
                        [FORMNAME]="'otherPoliciesParentForm'"
                        [CHILDGRIDFORM]="otherPoliciesChildForm"
                        [componentMetaData]="configData.ComponentMetaDataConfiguration.OtherPoliciesComponentNB"
                        (componentOutput)="_BaseEmitHandler($event, 'OtherPolicyComponent')"
                        [transactionState]="mapperTransactionState" [currentComponent]="'OtherPolicyComponent'"
                        [IO]="payloadInEdit">
                      </app-input-grid-nested>
                    </div>
                    <div *ngIf="mapperTransactionState ==='proposal_ManualUw' || mapperTransactionState ==='LIFEproposal_ManualUw'">
                      <app-input-grid-nested
                        [FORMNAME]="'otherPoliciesParentForm'"
                        [CHILDGRIDFORM]="otherPoliciesChildForm"
                        [componentMetaData]="configData.ComponentMetaDataConfiguration.OtherPoliciesComponentUW"
                        (componentOutput)="_BaseEmitHandler($event, 'OtherPolicyComponent')"
                        [transactionState]="mapperTransactionState" [currentComponent]="'OtherPolicyComponent'"
                        [IO]="payloadInEdit">
                      </app-input-grid-nested>
                    </div>
                  </div>
                 
                </nz-collapse-panel>
              </nz-collapse>
            </div>

            <!-- Follow Up Screen -->
            <div>
              <nz-collapse [nzBordered]="false" class="panel-custom-unified">
                <nz-collapse-panel [nzActive]="true" [nzHeader]="titleTmplFollowUpScreen" [ngStyle]="panelCustomStyle"
                  [nzExpandedIcon]="panelIcon||undefined">
                  <ng-template #titleTmplFollowUpScreen>
                    <div class="heading-tab panel-custom-unified-collapse-heading">
                      <h3 class="heading"><i nz-icon nzType="file-text"></i>Follow Up</h3>
                    </div>
                  </ng-template>
                  <div class="list-view-margin">
                    <app-input-grid-nested [componentMetaData]="configData.ComponentMetaDataConfiguration.followUpComponent"
                      (componentOutput)="_BaseEmitHandler($event, 'followUpComponent')"
                      [transactionState]="mapperTransactionState" [currentComponent]="'followUpComponent'"
                      [IO]="payloadInEdit">
                    </app-input-grid-nested>
                  </div>
                </nz-collapse-panel>
              </nz-collapse>
             
            </div>

            <!-- Receipting -->
            <div>
              <nz-collapse [nzBordered]="false" class="panel-custom-unified">
                <nz-collapse-panel [nzActive]="true" [nzHeader]="titleTmplReceipting" [ngStyle]="panelCustomStyle"
                  [nzExpandedIcon]="panelIcon||undefined">
                  <ng-template #titleTmplReceipting>
                    <div class="heading-tab panel-custom-unified-collapse-heading">
                      <h3 class="heading"><i nz-icon nzType="file-done"></i>Receipting 2</h3>
                    </div>
                  </ng-template>
                  <div class="list-view-margin">
                    <!-- <app-receipting [viewFromTab]='true'></app-receipting> -->
                    <app-receipting [viewFromTab]='true' [configData]="configData" 
                    [transactionState]="mapperTransactionState" [IO]="payloadInEdit" 
                    (componentOutput)="_BaseEmitHandler($event, 'ReceiptingComponent')" (changedField)="getDataOnChange($event)"></app-receipting>
                  </div>
                </nz-collapse-panel>
              </nz-collapse>
             
            </div>
            <nz-tab [nzTitle]="titleTmplBasicDtl" *ngIf="getTabVisibilityStatus('BasicDetails')"
            (nzSelect)="log(['select', tab])" (nzClick)="log(['click', tab])" (nzDeselect)="log(['deselect', tab])">
            <ng-template #titleTmplBasicDtl>
              <i nz-icon nzType="file-protect"></i> Vehicle Details
            </ng-template>
            <div [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw'">

              <app-vehicle-details [inputDataForEdit]="_inputVehicleDetailsComponent"
                [DOName]="_getDOName(TransactionState)" [transactionState]="mapperTransactionState"
                [proposalType]="proposalType" [configData]="configData" [product]="selectedProduct"
                [productFamilyCd]="productFamilyCd" (policyPackageType)="getPackageType($event)"
                (componentOutput)="_BaseEmitHandler($event, 'MotorInsuredDetailsComponent')">
              </app-vehicle-details>

            </div>

          </nz-tab>

            <!-- Medical Risk -->
            <!-- <nz-tab [nzTitle]="titleTmplMedicalRisk"
            (nzSelect)="log(['select', tab])" (nzClick)="log(['click', tab])" (nzDeselect)="log(['deselect', tab])">
            <ng-template #titleTmplMedicalRisk>
              <i nz-icon nzType="file-done"></i> Medical Risk
            </ng-template>
            <div>
              <app-medical-risk></app-medical-risk>
            </div>
          </nz-tab> -->



            <!-- Vehicle Details -->
            <ng-container *ngIf="this.tempInVisible;">

              <nz-tab [nzTitle]="titleTmplBasicDtl" *ngIf="getTabVisibilityStatus('VehicleDetails')"
                (nzSelect)="log(['select', tab])" (nzClick)="log(['click', tab])" (nzDeselect)="log(['deselect', tab])">
                <ng-template #titleTmplBasicDtl>
                  <i nz-icon nzType="file-text"></i> Vehicle Details
                </ng-template>
                <div [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw'">
                  <app-generic-zero-ui [list]="this.tempAgentDetail"></app-generic-zero-ui>
                </div>
              </nz-tab>
            </ng-container>

            <!-- Trip -->
            <ng-container *ngIf="this.tempInVisible;">

              <nz-tab [nzTitle]="titleTmplBasicDtl" *ngIf="getTabVisibilityStatus('TripDetails')"
                (nzSelect)="log(['select', tab])" (nzClick)="log(['click', tab])" (nzDeselect)="log(['deselect', tab])">
                <ng-template #titleTmplBasicDtl>
                  <i nz-icon nzType="file-text"></i> Trip
                </ng-template>
                <div [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw'">
                  <app-generic-zero-ui [list]="this.tempAgentDetail"></app-generic-zero-ui>
                </div>
              </nz-tab>
            </ng-container>

            <!-- Property -->
            <ng-container *ngIf="this.tempInVisible;">

              <nz-tab [nzTitle]="titleTmplBasicDtl" *ngIf="getTabVisibilityStatus('PropertyDetails')"
                (nzSelect)="log(['select', tab])" (nzClick)="log(['click', tab])" (nzDeselect)="log(['deselect', tab])">
                <ng-template #titleTmplBasicDtl>
                  <i nz-icon nzType="file-text"></i> Property
                </ng-template>
                <div [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw'">
                  <app-generic-zero-ui [list]="this.tempAgentDetail"></app-generic-zero-ui>
                </div>
              </nz-tab>
            </ng-container>

            <!-- Claim Decision added by Abhishek -->
            <!-- <nz-tab [nzTitle]="titleTmplUWDecision" *ngIf="getTabVisibilityStatus('ClaimDecision')">
          <ng-template #titleTmplUWDecision>
            <i nz-icon nzType="exception"></i> Final Underwriting Decision
          </ng-template>
          <app-underwriting-decision [inputDataForEdit]="_inputClaimDecisionComponent"
            [transactionState]="mapperTransactionState"
            (componentOutput)="_BaseEmitHandler($event, 'UnderwritingDecisionComponent')"
            [DOName]="_getDOName(mapperTransactionState)"></app-underwriting-decision>
        </nz-tab> -->
            </div>
          <!-- </nz-tabset> -->
          <!-- Integration -->
          <nz-tabset *ngIf="isEditWithConfig">
            <ng-container *ngFor="let tab of tabsets">
              <nz-tab [nzTitle]="tabTitleTemplate">
                <ng-template #tabTitleTemplate>
                  <i nz-icon [nzType]="tab.icon"></i> {{tab.name}}
                </ng-template>
                <ng-container *ngFor="let section of tab.sections">
                  <!-- <pre>{{tab.sections | json}}</pre> -->
                  <ng-container [ngSwitch]="section.type">
                    <ng-container *ngSwitchCase="'form'">
                      <app-dynamic-form *ngIf="refreshComponentToggle" baseDOName="proposalDO"
                        [FORMTITLE]="section.heading" [FORMNAME]="section.controlId"
                        [currentComponentName]="section.controlId"
                        [(ngModel)]="currentAllComponentData[section.controlId]" [emitComponentDataInNgModel]="true"
                        [dynamicRenderingMode]="true" [formMetaData]="section.formItems" [IO]="payloadInEdit">
                      </app-dynamic-form>
                    </ng-container>
                    <ng-container *ngSwitchCase="'editable-grid'">
                      <!-- <span style="color: red;">Section type received in config not yet supported</span> -->
                      <app-light-grid *ngIf="refreshComponentToggle" [metaDataConfig]="section"
                        [(ngModel)]="currentAllComponentData[section.controlId]"
                        [currentComponentName]="section.controlId" [IO]="payloadInEdit">
                      </app-light-grid>
                      <!-- <app-input-grid-nested [componentMetaData]="section" [transactionState]="mapperTransactionState"
                      [currentComponent]="section.controlId" [IO]="payloadInEdit"
                      (componentOutput)="_BaseEmitHandler($event, section.controlId)"></app-input-grid-nested> -->
                    </ng-container>
                    <ng-container *ngSwitchCase="'light-grid'">
                      <app-light-grid [metaDataConfig]="section" [(ngModel)]="payloadInEdit">
                      </app-light-grid>
                    </ng-container>
                    <ng-container *ngSwitchCase="'custom-component'">
                      <ng-container *ngFor="let component of section.formItems">
                        <ng-container [ngSwitch]="component.fieldKey">

                          <ng-container *ngSwitchCase="'RulesAutoComponent_UWRules'">
                            <app-rules-auto *ngIf="payloadInEdit" [IO]="payloadInEdit"></app-rules-auto>
                          </ng-container>

                          <ng-container *ngSwitchCase="'PaymentBreakupComponent'">
                            <app-payment-breakup *ngIf="refreshThisComponenetOnSaveSubmit"
                              (componentOutput)="_BaseEmitHandler($event, 'PaymentBreakupDetails')"
                              [inputDataForEdit]="payloadInEdit">
                            </app-payment-breakup>
                          </ng-container>

                          <ng-container *ngSwitchCase="'CapturedClientListComponent_PAYER'">
                            <div [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw' || disableTransaction"
                              *ngIf="refreshPayerFlag">
                              <!-- PAYER -->
                              <!-- {{copySourceForClaimant | json}} -->
                              <app-captured-client-list [configData]="configData" captureRole="PAYER" [operationMode]="MULTI"
                                [clientList]="payerDataSet" [allowEditInsured]="FALSEVALUE"
                                (openSearchModal)="editClient('modSearchCustomerPayer', $event)"
                                [copySource]="copySourceForClaimant" [enableClientAsPayer]="FALSEVALUE"
                                [allowedCount]="noOfClientsCanBeAdded.PAY" [transactionState]="mapperTransactionState"
                                (componentOutput)="_BaseEmitHandler($event, 'CapturedClientListComponentPAYER')"
                                (updateClientList)="updateClientList($event,'PAYER')"
                                [inputDataForEdit]="_inputAllClientListComponent">
                              </app-captured-client-list>

                              <!-- <app-multicapture-bank-details [IO]="payloadInEdit"
                                [inputDataForEdit]="_inputMulticaptureBankDetailsComponent"
                                [transactionState]="mapperTransactionState"
                                [bankBeneficiaryRole]="this.setRolesBeneficiary"
                                (componentOutput)="_BaseEmitHandler($event, 'MulticaptureBankDetailsComponent')">
                              </app-multicapture-bank-details> -->
                              <bank-details [showComponent]="claimClientRoles_HM.has('PAYER') && claimClientRoles_HM.get('PAYER').size > 0" [componentName]="'BankDetailsComponent'" [IO]="payloadInEdit" [emitToTransaction]="true"
                              (componentOutput)="_BaseEmitHandler($event, 'BankDetailsComponent')" [transactionState]="mapperTransactionState"
                              [inputDataForEdit]="_inputBankDetailsComponent" [bankBeneficiaryRole]="this.setRolesBeneficiary"(changedField)="getDataOnChange($event)">
                            </bank-details>
                            </div>
                          </ng-container>

                          <ng-container *ngSwitchCase="'SubmissionDataComponent'">
                            <div [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw' || disableTransaction">

                              <app-submission-data [inputDataForEdit]="_inputSubmissionDataComponent"
                                [DOName]="_getDOName(TransactionState)" [transactionState]="mapperTransactionState"
                                [proposalType]="proposalType" [configData]="configData" [product]="selectedProduct"
                                [productFamilyCd]="productFamilyCd" (policyPackageType)="getPackageType($event)"
                                (componentOutput)="_BaseEmitHandler($event, 'SubmissionDataComponent')" (changedField)="getDataOnChange($event)">
                              </app-submission-data>

                            </div>
                          </ng-container>
                          <ng-container *ngSwitchCase="'CapturedClientListComponent_OWNER'">
                            <div [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw' || disableTransaction">
                              <!-- <app-dynamic-form FORMNAME="submissionDataForm" FORMTITLE="Addition Fields" [IO]="payloadInEdit"></app-dynamic-form> -->
                              <!-- Primary Insured -->
                              <!-- <app-captured-client-list [configData]="configData" captureRole="OWNER"
                                (clientEmitterToCopy)="updateClientList($event,'OWNER')"
                                [allowClientToBeCopied]="TRUEVALUE" [allowEditInsured]="FALSEVALUE"
                                [operationMode]="SINGLE" [clientList]="ownerDataSet" [enableClientAsPayer]="TRUEVALUE"
                                [addNominee]="true" (openSearchModal)="editClient('modSearchCustomerOwner', $event)"
                                [transactionState]="mapperTransactionState" [allowedCount]="noOfClientsCanBeAdded.PH"
                                (componentOutput)="_BaseEmitHandler($event, 'CapturedClientListComponentOWNER')"
                                (emittedClient)="_EmittedClientHandler($event, 'PRIMARYINSURED')"
                                [inputDataForEdit]="_inputAllClientListComponent">
                              </app-captured-client-list> -->
                            </div>
                          </ng-container>

                          <ng-container *ngSwitchCase="'CapturedClientListComponent_PRIMARYINSURED'">
                            <div [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw' || disableTransaction"
                              *ngIf="refreshPrimaryInsuredFlag">
                              <!-- Primary Insured -->
                              <!-- <app-captured-client-list [configData]="configData" captureRole="PRIMARYINSURED"
                                (updateClientList)="updateClientList($event,'PRIMARYINSURED')" [operationMode]="SINGLE"
                                [clientList]="primaryInsuredDataSet" [allowedCount]="noOfClientsCanBeAdded.PI"
                                [enableClientAsPayer]="FALSEVALUE" [addNominee]="true"
                                (openSearchModal)="editClient('modSearchCustomerPrimaryInsured', $event)"
                                [transactionState]="mapperTransactionState"
                                (componentOutput)="_BaseEmitHandler($event, 'CapturedClientListComponentPRIMARYINSURED')"
                                [inputDataForEdit]="_inputAllClientListComponent">
                              </app-captured-client-list> -->
                            </div>
                          </ng-container>

                          <ng-container *ngSwitchCase="'CapturedClientListComponent_INSURED'">
                            <div [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw' || disableTransaction">
                              <!-- Member -->
                              <!-- <app-captured-client-list [configData]="configData" captureRole="INSURED"
                                (clientEmitterToCopy)="updateClientList($event,'INSURED')"
                                [allowClientToBePrimaryInsured]="FALSEVALUE" [allowedCount]="noOfClientsCanBeAdded.IN"
                                [enableClientAsPayer]="FALSEVALUE" [addNominee]="true"
                                [allowClientToCaptureRelationship]="FALSEVALUE" [operationMode]="MULTI"
                                [clientList]="insuredDataSet"
                                (openSearchModal)="editClient('modSearchCustomerInsured', $event)"
                                [transactionState]="mapperTransactionState"
                                (componentOutput)="_BaseEmitHandler($event, 'CapturedClientListComponentINSURED')"
                                [inputDataForEdit]="_inputAllClientListComponent">
                              </app-captured-client-list> -->
                            </div>
                          </ng-container>
                          <ng-container *ngSwitchCase="'CapturedClientListComponent_NOMINEE'">
                            <div [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw' || disableTransaction">
                              <!--  Nominee -->
                              <!-- <app-captured-client-list [configData]="configData" captureRole="NOMINEE"
                                (clientEmitterToCopy)="updateClientList($event,'NOMINEE')"
                                [allowClientToBeCopied]="FALSEVALUE" [operationMode]="MULTI"
                                [clientList]="nomineeDataSet" [enableSplitPercentage]="TRUEVALUE"
                                [allowedCount]="noOfClientsCanBeAdded.NOM" [enableClientAsPayer]="FALSEVALUE"
                                (openSearchModal)="editClient('modSearchNominee', $event)"
                                [transactionState]="mapperTransactionState" [allowClientToBeInsuredOwner]="TRUEVALUE"
                                (componentOutput)="_BaseEmitHandler($event, 'CapturedClientListComponentNOMINEE')"
                                (emittedClient)="_EmittedClientHandler($event, 'NOMINEE')"
                                [inputDataForEdit]="_inputAllClientListComponent" [IO]="payloadInEdit">
                              </app-captured-client-list> -->
                            </div>
                          </ng-container>
                          <ng-container *ngSwitchCase="'CapturedClientListComponent_APPOINTEE'">
                            <div [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw' || disableTransaction">
                              <div [hidden]="appMetadataHandler['LOB'] != 'LIFE'">
                                <!-- <app-captured-client-list [configData]="configData" captureRole="APPOINTEE"
                                  (clientEmitterToCopy)="updateClientList($event,'APPOINTEE')"
                                  [allowClientToBeCopied]="FALSEVALUE" [operationMode]="MULTI"
                                  [clientList]="appointeeDataSet" [allowedCount]="noOfClientsCanBeAdded.NOM"
                                  [enableClientAsPayer]="FALSEVALUE"
                                  (openSearchModal)="editClient('modSearchAppointee', $event)"
                                  [transactionState]="mapperTransactionState" [allowClientToBeInsuredOwner]="TRUEVALUE"
                                  (componentOutput)="_BaseEmitHandler($event, 'CapturedClientListComponentAPPOINTEE')"
                                  (emittedClient)="_EmittedClientHandler($event, 'APPOINTEE')"
                                  [inputDataForEdit]="_inputAllClientListComponent">
                                </app-captured-client-list> -->
                              </div>
                            </div>
                          </ng-container>

                          <ng-container *ngSwitchCase="'ProductCoveragesComponent'">
                            <div *ngIf="!refreshThisComponenetOnSaveSubmit"
                              style="display:block;border: 1px solid #dedede; padding: 40px; text-align:center;line-height: 1.5rem;color: #999">
                              Saving coverages and calculating premium
                            </div>

                            <nz-skeleton *ngIf="!refreshThisComponenetOnSaveSubmit" [nzAvatar]="false" [nzActive]="true"
                              [nzTitle]="true" [nzLoading]="!refreshThisComponenetOnSaveSubmit">
                            </nz-skeleton>
                            <div>
                              <app-product-coverages *ngIf="refreshThisComponenetOnSaveSubmit"
                                (componentOutput)="_BaseEmitHandler($event, 'ProductCoveragesComponent')"
                                (basePlanComponentOutput)="_BaseEmitHandler($event, 'BasePlanComponent')"
                                [product]="selectedProduct" [configData]="configData"
                                [transactionState]="mapperTransactionState" [transformType]="productFamilyCd"
                                [inputDataForEdit]="payloadInEdit" title="Base Plan" ExtractPlanTypeCd="RIDER">
                              </app-product-coverages>
                            </div>
                          </ng-container>
                          <ng-container *ngSwitchCase="'DECISIONBREAKUP'">
                            <!-- If decision for Policy is selected all other decisions are hidden -->
                            <ng-container *ngIf="appMetadataHandler.featureFlags.enableSingleDecisionOnDecisionBreakup">
                               <app-decision [configData]="configData" [DOName]="_getDOName(mapperTransactionState)" [inputDataForEdit]="_inputInsuredCoverageDecisionComponent"
                                  [transactionState]="mapperTransactionState"
                                  (componentOutputForDecisionForm) = "_BaseEmitHandler($event, 'ProposalDecisionComponent')"
                                  (componentOutputForCovergaeDecision) = "_BaseEmitHandler($event, 'CoverageDecisionComponent')">
                                </app-decision>
                            </ng-container>

                            <!-- Even If decision for Policy is selected all other decisions are visible -->
                            <ng-container
                              *ngIf="!appMetadataHandler.featureFlags.enableSingleDecisionOnDecisionBreakup">
                               <app-decision [configData]="configData" [DOName]="_getDOName(mapperTransactionState)" [inputDataForEdit]="_inputInsuredCoverageDecisionComponent"
                                  [transactionState]="mapperTransactionState"
                                  (componentOutputForDecisionForm) = "_BaseEmitHandler($event, 'ProposalDecisionComponent')"
                                  (componentOutputForCovergaeDecision) = "_BaseEmitHandler($event, 'CoverageDecisionComponent')">
                                </app-decision>
                            </ng-container>

                          </ng-container>
                          <ng-container *ngSwitchCase="'QUESTIONNAIRE'">
                            <div *ngIf="!appMetadataHandler.featureFlags.enableGenericQuestionnaire"
                              [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw' || disableTransaction">
                              <app-proposal-questionnaire
                                (componentOutput)="_BaseEmitHandler($event, 'QuestionnaireComponent')"
                                [IO]="payloadInEdit"></app-proposal-questionnaire>
                            </div>

                            <!-- [class.inputs-are-disabled]="mapperTransactionState == 'proposal_ManualUw'" -->
                            <div *ngIf="appMetadataHandler.featureFlags.enableGenericQuestionnaire">
                              <app-questionnaire *ngIf="refreshThisComponenetOnSaveSubmit"
                                (componentOutput)="_BaseEmitHandler($event, 'QuestionnaireComponent')"
                                [inputDataForEdit]="payloadInEdit">
                              </app-questionnaire>
                            </div>
                          </ng-container>
                          <ng-container *ngSwitchCase="'INTERMEDIARYDETAILS'">
                            <app-captured-agent-list captureRole="Intermediary Details" [agentList]="agentDataSet"
                              [transactionState]="mapperTransactionState"
                              (componentOutput)="_BaseEmitHandler($event, 'CapturedAgentListComponent')"
                              (openModal)="modSearchAgent=true" [inputDataForEdit]="_inputAgentListComponent">
                            </app-captured-agent-list>
                          </ng-container>
                          <ng-container *ngSwitchCase="'OTHERPOLICIES'">
                            <div
                              *ngIf="productFamilyCd == 'HEALTH' && appMetadataHandler.featureFlags.showOtherPoliciesGrid">
                              <div *ngIf="mapperTransactionState ==='proposal_DataEntry'">
                                <app-input-grid-nested
                                  [FORMNAME]="'otherPoliciesParentForm'"
                                  [CHILDGRIDFORM]="otherPoliciesChildForm"
                                  [componentMetaData]="configData.ComponentMetaDataConfiguration.OtherPoliciesComponentNB"
                                  (componentOutput)="_BaseEmitHandler($event, 'OtherPolicyComponent')"
                                  [transactionState]="mapperTransactionState"
                                  [currentComponent]="'OtherPolicyComponent'" [IO]="payloadInEdit">
                                </app-input-grid-nested>
                              </div>
                              <div *ngIf="mapperTransactionState ==='proposal_ManualUw'">
                                <app-input-grid-nested
                                  [FORMNAME]="'otherPoliciesParentForm'"
                                  [CHILDGRIDFORM]="otherPoliciesChildForm"
                                  [componentMetaData]="configData.ComponentMetaDataConfiguration.OtherPoliciesComponentUW"
                                  (componentOutput)="_BaseEmitHandler($event, 'OtherPolicyComponent')"
                                  [transactionState]="mapperTransactionState"
                                  [currentComponent]="'OtherPolicyComponent'" [IO]="payloadInEdit">
                                </app-input-grid-nested>
                              </div>
                            </div>
                            <div
                              *ngIf="productFamilyCd == 'LIFE' && appMetadataHandler.featureFlags.showOtherPoliciesGrid">
                              <div *ngIf="mapperTransactionState ==='proposal_DataEntry'">
                                <app-input-grid-nested
                                  [FORMNAME]="'otherPoliciesParentForm'"
                                  [CHILDGRIDFORM]="otherPoliciesChildForm"
                                  [componentMetaData]="configData.ComponentMetaDataConfiguration.OtherPoliciesComponentNB_LIFE"
                                  (componentOutput)="_BaseEmitHandler($event, 'OtherPolicyComponent')"
                                  [transactionState]="mapperTransactionState"
                                  [currentComponent]="'OtherPolicyComponent'" [IO]="payloadInEdit">
                                </app-input-grid-nested>
                              </div>
                              <div *ngIf="mapperTransactionState ==='proposal_ManualUw' || mapperTransactionState ==='LIFEproposal_ManualUw'">
                                <app-input-grid-nested
                                  [FORMNAME]="'otherPoliciesParentForm'"
                                  [CHILDGRIDFORM]="otherPoliciesChildForm"
                                  [componentMetaData]="configData.ComponentMetaDataConfiguration.OtherPoliciesComponentUW_LIFE"
                                  (componentOutput)="_BaseEmitHandler($event, 'OtherPolicyComponent')"
                                  [transactionState]="mapperTransactionState"
                                  [currentComponent]="'OtherPolicyComponent'" [IO]="payloadInEdit">
                                </app-input-grid-nested>
                              </div>
                            </div>
                          </ng-container>
                          <ng-container *ngSwitchCase="'FOLLOWUP'">
                            <div>
                              <app-input-grid-nested
                                [componentMetaData]="configData.ComponentMetaDataConfiguration.followUpComponent"
                                (componentOutput)="_BaseEmitHandler($event, 'followUpComponent')"
                                [transactionState]="mapperTransactionState" [currentComponent]="'followUpComponent'"
                                [IO]="payloadInEdit">
                              </app-input-grid-nested>
                            </div>
                          </ng-container>
                          <ng-container *ngSwitchCase="'RECEIPTING'">
                            <div>
                              <app-receipting [viewFromTab]='true'></app-receipting>
                            </div>
                          </ng-container>

                        </ng-container>
                      </ng-container>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </nz-tab>
            </ng-container>
          </nz-tabset>

        </div>
        
      </div>

      <!-- table layout -->
      <div>

      </div>

    </div>

    <div [hidden]="true">
      <div class="image-viewer-section m-t-20">
        <span>Proposal Form</span>
          <i class="f-r cursor-pointer" nz-icon nzType="close-circle" nzTheme="fill" (click)="dataTransformService.isSidebarCollapsed = !dataTransformService.isSidebarCollapsed;"></i>
        <!-- <button nz-button nzType="default" class="f-r" (click)="floatingPreviewScreen=true">
                  <i nz-icon nzType="arrows-alt" nzTheme="outline"></i>
                </button> -->
        <!-- <span (click)="floatingPreviewScreen=true" class="f-r"><i nz-icon nzType="arrows-alt"></i></span> -->
      </div>
      <span class="m-l-20">
        <label class="m-t-l-10" nz-checkbox [(ngModel)]="enableZoom" (ngModelChange)="enableTableView(enableZoom)">
          Enable Field Highlighter / Zoom
        </label>
      </span>
      <!-- <button [hidden]="togglePreviewBtn" nz-button nzType="default" class="togglePreview" (click)="togglePreview()">
        <i nz-icon nzType="menu-unfold" nzTheme="outline"></i>
      </button>
      <div [hidden]="!togglePreviewBtn" class="previewBoxContainer">
        <div class="previewBoxBorder">
          <div class="previewBoxFlex">
            <div class="previewBoxTitle">Zoom Preview
            </div>
            <button nz-button nzType="default" (click)="togglePreview()" style="margin: 10px;"><i nz-icon nzType="menu-fold"
                nzTheme="outline"></i></button>
          </div>
          <div id="myresult" class="img-zoom-result" style="background-color: #fff;"></div>
        </div>
      </div> -->
      <div *ngIf="!enableZoom">
        <angular-image-viewer id="imageViewer" [src]="splitModeImages" style="position: relative;"></angular-image-viewer>
      </div>
      <div *ngIf="enableZoom" #zoomContainerRef class="img-zoom-container" style="height: 550px; overflow-y: auto" (scroll)="scrollHandler($event)">
        <div id="lens-div" class="img-zoom-lens" (mousemove)="moveLens($event)"></div>
        <img id="myimage" style="height:auto;width: 500px;" [src]="singleImgViewer" (mousemove)="moveLens($event)">
      </div>
    </div>
  </div>


  <!-- Save/Actions Footer -->
  <div *ngIf="!enableActionButton">
    <div class="card-summary-data-footer __data-footer-primary button-container">
      <div class="button-group">
        <button nz-button nz-dropdown [nzDropdownMenu]="menuDD" class="m-r-10">
          Actions <i nz-icon nzType="down"></i>
        </button>
  
        <nz-dropdown-menu #menuDD="nzDropdownMenu">
          <ul nz-menu>
            <ng-container>
              <li *ngFor="let item of (lookup$['secondaryTasks'] | async) as roleUsersLookup; trackBy: item?.lookupKey"
                nz-menu-item (click)="openCollaborationModal()">
                <a>{{ item?.lookupValue }}</a>
              </li>
            </ng-container>
            <ng-container *ngIf="mapperTransactionState == 'REFERRALS'">
              <li nz-menu-item *ngIf="showAcknowledge"><a (click)="submitAcknowledge()">Acknowledge</a></li>
              <li nz-menu-item *ngIf="showInterim"><a (click)="submitInterim()">Interim Report</a></li>
              <li nz-menu-item *ngIf="showFinal"><a (click)="submitCLaimInvestigation()">Final Report</a></li>
            </ng-container>
            <ng-container>
              <li nz-menu-item (click)="showAssignModal()">Reassign</li>
            </ng-container>
          </ul>
        </nz-dropdown-menu>
  
        <button id="submitButton" nz-button class="m-r-10" [nzType]="'default'"
          [disabled]="!dataSubmittedFlag || disableSaveSubmitButton"
          (click)="attemptForTransaction('submit')">Submit</button>
        <button id="saveButton" nz-button [nzType]="'primary'" [disabled]="!dataSubmittedFlag || disableSaveSubmitButton"
          (click)="attemptForTransaction('save')">Save</button>
  
      </div>
    </div>
  </div> 
  <div *ngIf="enableActionButton">
    <div class="card-summary-data-footer __data-footer-primary button-container">
      <div class="m-r-10">
        <button class="m-r-10" id="acceptButton" nz-button [nzType]="'default'" [disabled]="!dataSubmittedFlag"
          (click)="onActionClicked('ACCEPT')">
          Accept
        </button>
  
        <button id="rejectButton" nz-button [nzType]="'default'" [disabled]="!dataSubmittedFlag"
          (click)="onActionClicked('REJECT')">
          Reject
        </button>
      </div>
    </div>
  </div>

  <!-- TODO ninad transaction tabs end  -->
  <div
    *ngIf="((payloadInEdit && payloadInEdit['exceptionDOList'] && payloadInEdit['exceptionDOList'].length > 0) || (_UIErrorList && _UIErrorList.length > 0))"
    class="error-panel" [ngClass]="{'error-panel-collapsed': errPanelCollapsed}">

    <!-- Heading -->
    <div class="flexie-auto-grid clickable p-b-5" (click)="errorPanelToggle()">
      <div>
        <h4 class="col-red">Exceptions</h4>
      </div>
      <div class="text-a-right d-b">
        <i *ngIf="!errPanelCollapsed" class="anticon anticon-down"></i>
        <i *ngIf="errPanelCollapsed" class="anticon anticon-up"></i>
      </div>
    </div>

    <!-- Errors List -->
    <div>
      <ng-container
        *ngIf="payloadInEdit && payloadInEdit['exceptionDOList'] && payloadInEdit['exceptionDOList'].length > 0">

        <strong class="col-grey-dark">Validation Exceptions</strong>
        <ul class="error-list">
          <li *ngFor="let exception of payloadInEdit['exceptionDOList']">
            <span>{{exception?.exceptionType}} : {{exception?.exceptionMessage}}</span>
          </li>
          <div
            *ngIf="payloadInEdit && payloadInEdit['exceptionDOList'] && payloadInEdit['exceptionDOList'].length == 0">
            No
            Exceptions found</div>
        </ul>

      </ng-container>


      <ng-container *ngIf="_UIErrorList && _UIErrorList.length > 0">

        <strong class="col-grey-dark">Invalid Data</strong>
        <ul class="error-list">
          <li *ngFor="let error of _UIErrorList">
            <span>{{error?.fieldNameDescription}} : {{error?.errorMsg}}</span>
          </li>
          <div *ngIf="_UIErrorList && _UIErrorList.length == 0">No
            Exceptions found</div>
        </ul>

      </ng-container>

      <!-- <strong class="col-grey-dark">Business Exceptions</strong>
    <ul class="error-list">
      <div>No Exceptions found</div>
    </ul> -->
    </div>

    <!-- View all -->
    <!-- <a (click)="errDetailsPanel(1)" class="d-b col-grey-dark p-t-b-5 b-1 text-a-center">View All</a> -->

  </div>


  <!-- MODALS -->

  <!-- ReAssign component -->

  <nz-modal [(nzVisible)]="modShowReassign" nzTitle="Reassign Tasks" (nzOnCancel)="modShowReassign=false"
    [nzFooter]="null" nzWidth="600px">
    <ng-container *nzModalContent>
      <app-reassign-task [tasksList]="taskList"  (closeModal)="modShowReassign = false"></app-reassign-task>
    </ng-container>
  </nz-modal>

  <nz-modal [(nzVisible)]="emitterStatusModal" nzTitle="Component Emitter Log" nzCancelDisabled
    (nzOnOk)="emitterStatusModal = !emitterStatusModal" nzWidth="1000px">
    <ng-container *nzModalContent>
      <nz-table #emitterTable [nzData]="emitterStatusForView">
        <thead>
          <tr>
            <th>Sr. No.</th>
            <th>Name</th>
            <th>Emitted</th>
            <th>IsExtra</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of emitterTable.data; let i = index">
            <td>{{i+1}}</td>
            <td>{{data?.componentName}}</td>
            <td>{{data?.emitted? 'Working' : 'Not Working' }}</td>
            <td>{{data?.emitted && data?.isExtra? 'Remove from StateToChildComponentMapper': 'No' }}</td>
          </tr>
        </tbody>
      </nz-table>
    </ng-container>
  </nz-modal>

  <nz-modal [(nzVisible)]="modInvtgVis" [nzTitle]="modalTitle" (nzOnCancel)="modInvtgVis=false" (nzOnOk)="refertoUser()"
    nzOkText="Refer" nzWidth="600px">
    <ng-container *nzModalContent>
      <div *ngIf="modInvtgVis">

        <div class="flex flex-horiz-space-bw">
          <h4>Enter your Notes</h4>
          <nz-dropdown *ngIf="reffrelUserType == 'INVESTIGATOR'" [nzPlacement]="'bottomRight'">
            <a nz-dropdown class="col-grey-dark">Canned Replies <i nz-icon nzType="down"></i></a>
            <ul nz-menu>
              <li nz-menu-item (click)="noteCannedReply(0)">Please have a look at the ...</li>
              <li nz-menu-item (click)="noteCannedReply(1)">Requesting additional investigation ...</li>
              <li nz-menu-item (click)="noteCannedReply(2)">Required Documents are not in place ...</li>
            </ul>
          </nz-dropdown>
        </div>
        <textarea *ngIf="reffrelUserType == 'INVESTIGATOR'" rows="2" nz-input [(ngModel)]="note"></textarea>
        <textarea *ngIf="reffrelUserType != 'INVESTIGATOR'" rows="5" nz-input [(ngModel)]="note"></textarea>

        <h4 class="d-b m-t-20" *ngIf="reffrelUserType == 'INVESTIGATOR'">Investigate:</h4>
        <nz-select nzShowSearch nzMode="tags" *ngIf="reffrelUserType == 'INVESTIGATOR'" style="width: 100%;"
          [ngModel]="'Hospital Records'">
          <nz-option nzLabel="Hospital Records" nzValue="Hospital Records"> </nz-option>
          <nz-option nzLabel="Death Certificate" nzValue="Death Certificate"> </nz-option>
          <nz-option nzLabel="Cross-check with Doctor" nzValue="Cross-check with Doctor"> </nz-option>
        </nz-select>


        <h4 class="d-b m-t-20" *ngIf="reffrelUserType == 'INVESTIGATOR'">Attach Files/Documents</h4>

        <!-- Upload table -->
        <nz-table *ngIf="reffrelUserType == 'INVESTIGATOR'" #basicTable [nzData]="dataSet" [nzShowPagination]="false">
          <thead>
            <tr>
              <th>Type</th>
              <th>Comment</th>
              <th>Document</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Claim Form</td>
              <td>Please check this in detail</td>
              <td><a>fc_023_scan.pdf</a></td>
              <td>
                <!-- Actions -->
                <span class="m-r-10"><i nz-icon nzType="eye" nzTheme="outline"></i></span>
                <span><i class="anticon anticon-delete col-red"></i></span>
              </td>
            </tr>
          </tbody>
        </nz-table>
        <a *ngIf="reffrelUserType == 'INVESTIGATOR'">Add more</a>



        <h4 class="d-b m-t-20">Assign to</h4>
        <!-- <nz-select nzShowSearch class="w-100-pc"  nzAllowClear nzPlaceHolder="Select a person">
      <nz-option nzLabel="Jack Nicholson (Golden Bay Area)" nzValue="1"></nz-option>
      <nz-option nzLabel="Lucy Liu (Hypercity Area)" nzValue="2"></nz-option>
      <nz-option nzLabel="Tom Hardy (New Delhi Area)" nzValue="3"></nz-option>
    </nz-select> -->
        <nz-select nzShowSearch id="eventType" style="width: 100%" [(ngModel)]="assigneeUser">
          <nz-option *ngFor="let item of (lookup$.csrUsersUID | async) as eventTypeCdLookup; trackBy:item?.lookupKey"
            [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupValue"></nz-option>
        </nz-select>
      </div>
    </ng-container>

  </nz-modal>

  <nz-modal [(nzVisible)]="modalCorrespNew" nzTitle="New Correspondence" (nzOnCancel)="modalCorrespNew=false"
    (nzOnOk)="modalCorrespNew=false" nzOkText="Send" nzWidth="75%" nzZIndex="=1400">
    <ng-container *nzModalContent>
      <div *ngIf="modalCorrespNew">

        <nz-radio-group [(ngModel)]="correspType" [nzButtonStyle]="'solid'" [nzSize]="'default'">
          <label nz-radio-button nzValue="email"><i nz-icon nzType="mail" nzTheme="outline"></i> Email</label>
          <label nz-radio-button nzValue="sms"><i nz-icon nzType="mobile" nzTheme="outline"></i> SMS</label>
          <label nz-radio-button nzValue="pdf"><i nz-icon nzType="file-pdf" nzTheme="outline"></i> PDF</label>
        </nz-radio-group>


        <div *ngIf="'email'==correspType">
          <h4 class="d-b m-t-20">To</h4>
          <!-- Multi emails; ENTER to add new entry -->
          <nz-select nzShowSearch nzMode="tags" style="width: 100%;" [ngModel]="'liam@thehemsworths.com'">
            <nz-option nzLabel="liam@thehemsworths.com" nzValue="liam@thehemsworths.com"></nz-option>
            <nz-option nzLabel="chris@thehemsworths.com" nzValue="chris@thehemsworths.com"></nz-option>
            <nz-option nzLabel="robert@thehemsworths.com" nzValue="robert@thehemsworths.com"></nz-option>
          </nz-select>


          <h4 class="d-b m-t-20">Content</h4>

          <angular-editor [(ngModel)]="correspondenceRichText"></angular-editor>


          <h4 class="d-b m-t-20">Attach Files/Documents</h4>

          <!-- Upload table -->
          <nz-upload nzType="drag" [nzMultiple]="true" [nzLimit]="2"
            nzAction="https://jsonplaceholder.typicode.com/posts/" (nzChange)="handleFileUpload($event)">
            <p class="ant-upload-drag-icon">
              <i nz-icon nzType="inbox" class="anticon anticon-inbox"></i>
            </p>
            <p class="ant-upload-text">Click or drag file to this area to upload</p>
            <p class="ant-upload-hint">
              Support for a single or bulk upload. Strictly prohibited from uploading internal company data or other
              confidential data
            </p>
          </nz-upload>


        </div>

        <div *ngIf="'sms'==correspType">
          <h4 class="d-b m-t-20">To (Mobile Numbers)</h4>
          <!-- Multi phone nos; ENTER to add new entry -->
          <nz-select nzShowSearch nzMode="tags" style="width: 100%;" [ngModel]="'9800560098'">
            <nz-option nzLabel="9800560098" nzValue="9800560098"> </nz-option>
          </nz-select>

          <h4 class="d-b m-t-20">Message</h4>
          <textarea nz-input value=""></textarea>

        </div>
      </div>
    </ng-container>
  </nz-modal>

  <nz-modal [(nzVisible)]="modSubmit" nzTitle="Submit" (nzOnCancel)="modSubmit=false" (nzOnOk)="modSubmit=false"
    nzOkText="Submit">
    <ng-container *nzModalContent>
      <div *ngIf="modSubmit">

        <h4>I have verified</h4>
        <span class="d-b p-t-b-10"><label nz-checkbox>Documents are in place</label></span>
        <span class="d-b p-t-b-10"><label nz-checkbox>Proofs matches with records</label></span>
        <span class="d-b p-t-b-10"><label nz-checkbox>Verified against discrepancies in claim</label></span>
        <span class="d-b p-t-b-10"><label nz-checkbox>Verified claim amount</label></span>

        <div class="m-t-20">
          <h4 class="d-i-b m-r-10">Logged in as</h4>
          <nz-avatar nzSize="small" nzIcon="user"></nz-avatar>&nbsp;
          John Doe
        </div>

      </div>

    </ng-container>

  </nz-modal>

  <!-- Search Policy or Client -->
     
  <nz-modal [nzClosable]="true" [(nzVisible)]="showClientSearchModal" [nzTitle]="searchClientMdalTitle"  nzMaskClosable="true" (nzOnCancel)="showClientSearchModal=false"
    (nzOnOk)="showClientSearchModal=false" nzOkText="Select" nzWidth="75%" [nzFooter]="null">
    <ng-container *nzModalContent>
    <app-generic-search searchMode="customerSearchOrCapture" [captureRole]="constants.ROLES[currentSelectedClientRole]"
      [inputDataForEdit]="editableClientData" (componentOutput)="getClientData($event)" (enableFooter)="setFooter($event)"  (closeModal)="showClientSearchModal = false">
    </app-generic-search>
    </ng-container>
  </nz-modal>

   <!-- Search Agent -->
   <nz-modal [(nzVisible)]="modSearchAgent" nzTitle="Search Intermediary" (nzOnCancel)="modSearchAgent=false"
   nzMaskClosable="false" (nzOnOk)="pingToAgentSearchForData()" nzOkText="Select" nzWidth="75%">
   <ng-container *nzModalContent>
     <app-generic-search *ngIf="modSearchAgent" modalFlag="modSearchAgent" searchMode="customerSearchOnly"
       captureRole="AGENT" (componentOutput)="getAgent($event)" (enableFooter)="setFooter($event)">
     </app-generic-search>
   </ng-container>
 </nz-modal>
  
  <!-- Rejection -->
  <nz-modal [(nzVisible)]="modRejectIntimation" nzTitle="Reject Intimation" (nzOnCancel)="modRejectIntimation=false"
    (nzOnOk)="modRejectIntimation=false" nzOkText="Reject" nzWidth="600px">
    <ng-container *nzModalContent>
      <div *ngIf="modRejectIntimation">

        <div class="flex flex-horiz-space-bw">
          <h4>Reason for Rejection</h4>
          <nz-dropdown [nzPlacement]="'bottomRight'">
            <a nz-dropdown class="col-grey-dark">Canned Replies <i nz-icon nzType="down"></i></a>
            <ul nz-menu>
              <li nz-menu-item (click)="noteCannedReply(2)">Required Documents are not in place ...</li>
              <nz-divider class="dd-extra-hr"></nz-divider>
              <li nz-menu-item>Manage Canned Replies</li>
            </ul>
          </nz-dropdown>
        </div>
        <textarea rows="2" nz-input [(ngModel)]="note"></textarea>

      </div>
    </ng-container>
  </nz-modal>

  <nz-modal [(nzVisible)]="openCollaboration" nzTitle="Collaboration" nzWidth="800px" [nzFooter]="null" (nzOnCancel)="openCollaboration = false">
    <ng-container *nzModalContent>
      <app-collaboration-modal [IO]="payloadInEdit" [transactionGuid]="transactionGuid"
        (closeModal)="openCollaboration = false"></app-collaboration-modal>
    </ng-container>
  </nz-modal>


  <!-- Hidden Content -- DRAWERS -->
  <!-- CORRESPONDENCE -->
  <nz-drawer [nzClosable]="true" [nzWidth]="390" [nzPlacement]="'right'" nzTitle="Correspondence with `Chris Hemsworth`"
    [nzVisible]="corresPanelOpen" (nzOnClose)="corresPanel(0)">
    <ng-container *nzDrawerContent>
      <div>

        <div class="p-b-10 flex flex-horiz-space-bw">
          <div></div>
          <button nz-button nzType="primary" (click)="openCorrModal()">New Correspondence</button>
        </div>

        <nz-timeline>
          <nz-timeline-item nzColor="green">
            <h4 class="f-w-600">eMail <nz-tag [nzColor]="'green'">Sent</nz-tag>
            </h4>
            <p><i class="anticon anticon-calendar"></i>5 Apr 2019 10:12 AM (5 days ago)</p>
            <p>
              <!-- To: riya@gmail.com <br> -->
              Message: Your proposal is being processed <br>
              Attachment: <a>P0000107.EML</a>
            </p>
          </nz-timeline-item>
          <nz-timeline-item nzColor="green">
            <h4 class="f-w-600">SMS <nz-tag [nzColor]="'green'">Sent</nz-tag>
            </h4>
            <p><i class="anticon anticon-calendar"></i>5 Apr 2019 10:12 AM (5 days ago)</p>
            <p>
              To: 9809862272 <br />
              Message: Your proposal is being processed
            </p>
          </nz-timeline-item>
        </nz-timeline>
      </div>
    </ng-container>
  </nz-drawer>

  <!-- DOCUMENT PANEL // DOCUMENT MANAGER -->
  <nz-drawer [nzClosable]="true" [nzWidth]="'50%'" [nzPlacement]="'right'" [nzTitle]="documentManagerDrawerTitleContent"
    [nzVisible]="dataTransformService.docuPanelOpen" (nzOnClose)="docuPanel(0)">
    <ng-container *nzDrawerContent>
      <div *ngIf="refreshThisComponenetOnSaveSubmit">
        <app-document-manager [requirements]="_inputDocumentManagerComponent && _inputDocumentManagerComponent['requirementDOs']"
          [inputDataForEdit]="_inputDocumentManagerComponent && _inputDocumentManagerComponent['entityDocumentDOs']"
          [clientDOHM]="clientDOHM"
          [RequirementEntityGuid]="transactionGuid" coreComponent=true
          (componentOutput)="_BaseEmitHandler($event, 'DocumentManagerComponent')" [documentManagerExpanded]="docManagerExpanded">
        </app-document-manager>
      </div>
    </ng-container>
    <div *ngIf="!docuPanelOpen" [hidden]="true">
      <div *ngIf="refreshThisComponenetOnSaveSubmit">
        <app-document-manager [requirements]="_inputDocumentManagerComponent && _inputDocumentManagerComponent['requirementDOs']"
          [inputDataForEdit]="_inputDocumentManagerComponent && _inputDocumentManagerComponent['entityDocumentDOs']"
          [clientDOHM]="clientDOHM"
          [RequirementEntityGuid]="transactionGuid" coreComponent=true
          (componentOutput)="_BaseEmitHandler($event, 'DocumentManagerComponent')" [documentManagerExpanded]="docManagerExpanded">
        </app-document-manager>
      </div>
    </div>
  </nz-drawer>

  <ng-template #documentManagerDrawerTitleContent>
    <span>
      Document Manager
    </span>
    <span class="doc-panel-resize">
      <i nz-icon nzType="fullscreen" nzTheme="outline" (click)="docPanelExpandedView()"></i>
    </span>
  </ng-template>
  <ng-template #documentManagerModalTitleContent>
    <span>
      Document Management Wizard
    </span>
    <span class="doc-panel-resize">
      <i nz-icon nzType="fullscreen-exit" nzTheme="outline" (click)="docPanelExpandedView()"></i>
    </span>
  </ng-template>

  <nz-modal [(nzVisible)]="docManagerExpanded" [nzTitle]="documentManagerModalTitleContent" [nzClosable]="true" [nzMaskClosable]="false" 
  (nzOnCancel)="docuPanel(0); docManagerExpanded=false" nzCancelText="Close"  [nzOkText]="null" 
  nzClassName="document-manager-modal" nzWidth="auto" [nzStyle]="{height: '100vh', top: '0' }">
  <div *ngIf="refreshThisComponenetOnSaveSubmit">
    <app-document-manager [requirements]="_inputDocumentManagerComponent && _inputDocumentManagerComponent['requirementDOs']"
      [clientDOHM]="clientDOHM"
      [inputDataForEdit]="_inputDocumentManagerComponent && _inputDocumentManagerComponent['entityDocumentDOs']"
      [RequirementEntityGuid]="transactionGuid" coreComponent=true
      (componentOutput)="_BaseEmitHandler($event, 'DocumentManagerComponent')" [documentManagerExpanded]="docManagerExpanded">
    </app-document-manager>
  </div>
</nz-modal>

  <!-- PENDING TASKS -->
  <nz-drawer [nzClosable]="true" [nzWidth]="390" [nzPlacement]="'right'" nzTitle="Pending Tasks for #CLM0000107"
    [nzVisible]="pendingPanelOpen" (nzOnClose)="pendingPanel(0)">
    <ng-container *nzDrawerContent>
      <div *ngIf="pendingPanelOpen">

        <nz-timeline>
          <nz-timeline-item nzColor="orange">
            <h4 class="f-w-600">Investigation <nz-tag [nzColor]="'orange'">Pending</nz-tag>
            </h4>
            <p><i class="anticon anticon-calendar"></i>5 Apr 2019 10:12 AM (5 days ago)</p>
            <p>
              Investigator: G. Fadango <br>
              Status: Being Investigated
            </p>
          </nz-timeline-item>
          <nz-timeline-item nzColor="orange">
            <h4 class="f-w-600">Missing Document <nz-tag [nzColor]="'orange'">Pending</nz-tag>
            </h4>
            <p><i class="anticon anticon-calendar"></i>5 Apr 2019 10:12 AM (5 days ago)</p>
            <p>
              Notes: Correspondence sent to Claimant
            </p>
          </nz-timeline-item>
        </nz-timeline>

      </div>
    </ng-container>

  </nz-drawer>
</ng-container>
<!-- END Hidden Content -->